(function () {
  if (window.__roverProductPageScriptLoaded) return;
  window.__roverProductPageScriptLoaded = true;

  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  // Temporary conservative TVC mode: keep the scroll sequence code below, but bypass it in production.
  var forceStaticPerspective = true;

  function prefersReducedMotion() {
    return reduceMotionQuery && reduceMotionQuery.matches;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getLayoutViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 1;
  }

  function getViewportCenterWithin(containerRect, viewportWidth) {
    var rectLeft = containerRect && Number.isFinite(containerRect.left) ? containerRect.left : 0;
    return (viewportWidth / 2) - rectLeft;
  }

  function escapeSelector(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function getRestrictedPurchaseRoot(element) {
    if (!element || !element.closest) return null;
    return element.closest('[data-rover-purchase-restricted="true"], .is-market-restricted');
  }

  function isRestrictedPurchaseElement(element) {
    return !!getRestrictedPurchaseRoot(element);
  }

  function getRestrictedPurchaseMessage(element) {
    var root = getRestrictedPurchaseRoot(element);
    if (!root) return 'Rover is not available for purchase in your current region.';
    return root.getAttribute('data-rover-restricted-message') || 'Rover is not available for purchase in your current region.';
  }

  function getShopifyRouteRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getRoverCartDrawer() {
    return document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
  }

  function getRoverSectionId(element) {
    if (!element) return '';
    var section = element.classList && element.classList.contains('shopify-section') ? element : (element.closest ? element.closest('.shopify-section') : null);
    return section && section.id ? section.id.replace('shopify-section-', '') : '';
  }

  function setRoverCartLayer(isOpen) {
    document.documentElement.classList.toggle('rover-cart-open', !!isOpen);
    if (document.body) document.body.classList.toggle('rover-cart-open', !!isOpen);
  }

  function replaceRoverCartDrawer(html) {
    if (!html) return false;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('#cart-drawer');
    var current = getRoverCartDrawer();
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    return true;
  }

  function replaceRoverCartDrawerFromSections(sections) {
    if (!sections) return false;
    var drawer = getRoverCartDrawer();
    var sectionId = getRoverSectionId(drawer);
    var html = sectionId && sections[sectionId] ? sections[sectionId] : sections['cart-drawer'];
    if (!html) {
      Object.keys(sections).some(function (key) {
        if (key.indexOf('cart-drawer') === -1) return false;
        html = sections[key];
        return true;
      });
    }
    return replaceRoverCartDrawer(html);
  }

  function getRoverCartDrawerSectionId() {
    return getRoverSectionId(getRoverCartDrawer()) || 'cart-drawer';
  }

  function showRoverCartDrawerElement(drawer) {
    if (!drawer) return false;

    if (typeof drawer.show === 'function') {
      try {
        drawer.show();
        return true;
      } catch (error) {}
    }

    if (typeof drawer.showModal === 'function') {
      try {
        drawer.showModal();
        return true;
      } catch (error) {}
    }

    if (typeof drawer.open === 'function') {
      try {
        drawer.open();
        return true;
      } catch (error) {}
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    return true;
  }

  function reinforceRoverCartDrawerOpen() {
    window.setTimeout(function () {
      setRoverCartLayer(true);
      showRoverCartDrawerElement(getRoverCartDrawer());
    }, 80);

    window.setTimeout(function () {
      setRoverCartLayer(true);
      showRoverCartDrawerElement(getRoverCartDrawer());
    }, 260);
  }

  function openRoverCartDrawer(options) {
    var opts = options || {};
    if (opts.sections) replaceRoverCartDrawerFromSections(opts.sections);
    setRoverCartLayer(true);
    var drawer = getRoverCartDrawer();

    if (showRoverCartDrawerElement(drawer)) {
      reinforceRoverCartDrawerOpen();
      return true;
    }

    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger && typeof trigger.click === 'function') {
      trigger.click();
      reinforceRoverCartDrawerOpen();
      return true;
    }

    return false;
  }

  function bindRoverCartLayerBridge() {
    if (window.__roverCartLayerBridgeBound === 'true') return;
    window.__roverCartLayerBridgeBound = 'true';
    window.roverOpenCartDrawer = openRoverCartDrawer;

    document.addEventListener('variant:add', function (event) {
      var target = event.target;
      var detail = event.detail || {};
      var source = detail.form || detail.source || target;
      var active = document.activeElement;
      var isRoverPurchaseEvent = false;

      [source, target, active].some(function (candidate) {
        if (!candidate || !candidate.closest) return false;
        isRoverPurchaseEvent = !!candidate.closest('.rover-purchase-drawer');
        return isRoverPurchaseEvent;
      });

      if (!isRoverPurchaseEvent) return;
      openRoverCartDrawer({ sections: detail.cart && detail.cart.sections });
      reinforceRoverCartDrawerOpen();
    }, true);

    document.addEventListener('dialog:after-hide', function (event) {
      if (event.target && event.target.id === 'cart-drawer') setRoverCartLayer(false);
    });

    document.addEventListener('toggle', function (event) {
      if (event.target && event.target.id === 'cart-drawer' && !event.target.hasAttribute('open')) setRoverCartLayer(false);
    });
  }

  function applyRoverPurchaseRegionLock(scope) {
    var rootScope = scope || document;
    var restrictedRoots = [];

    if (rootScope.matches && rootScope.matches('[data-rover-purchase-restricted="true"], .is-market-restricted')) {
      restrictedRoots.push(rootScope);
    }

    restrictedRoots = restrictedRoots.concat(Array.prototype.slice.call(rootScope.querySelectorAll('[data-rover-purchase-restricted="true"], .is-market-restricted')));

    restrictedRoots.forEach(function (root) {
      root.querySelectorAll('form[action*="/cart/add"], form[action$="/cart/add"]').forEach(function (form) {
        form.setAttribute('data-rover-purchase-restricted-form', 'true');
      });

      root.querySelectorAll('button[type="submit"], [data-rover-bundle-add], [data-rover-bundle-card-add]').forEach(function (button) {
        if (!button) return;
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      });
    });

    if (window.__roverPurchaseRegionLockBound === 'true') return;
    window.__roverPurchaseRegionLockBound = 'true';

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"], form[action$="/cart/add"]')) return;
      if (!isRestrictedPurchaseElement(form)) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('[data-rover-bundle-add], [data-rover-bundle-card-add], button[type="submit"]') : null;
      if (!target || !isRestrictedPurchaseElement(target)) return;
      event.preventDefault();
      event.stopPropagation();
      target.disabled = true;
      target.setAttribute('aria-disabled', 'true');

      var root = getRestrictedPurchaseRoot(target);
      var message = root ? root.querySelector('[data-rover-bundle-message], [data-rover-market-message]') : null;
      if (message) message.textContent = getRestrictedPurchaseMessage(target);
    }, true);
  }

  function prepareVideo(video, preload) {
    if (!video) return;
    var sourcesChanged = normalizeVideoElementSources(video);
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    var requestedPreload = preload || video.getAttribute('preload') || 'metadata';
    var shouldUpgradePreload = video.dataset.roverVideoPrepared === 'true' && requestedPreload === 'auto' && video.preload !== 'auto';
    video.preload = requestedPreload;

    var root = video.closest('[data-rover-perspective], [data-rover-vct], .rover-section');
    var poster = video.getAttribute('poster');

    if (poster && root && root.matches('[data-rover-perspective], [data-rover-vct]')) {
      root.style.setProperty('--rover-vct-poster-image', 'url("' + poster.replace(/"/g, '%22') + '")');
    }

    if (poster && video.dataset.roverPosterPreloadBound !== 'true') {
      video.dataset.roverPosterPreloadBound = 'true';
      var posterImage = new Image();
      posterImage.onload = function () {
        if (root) root.classList.add('is-vct-poster-ready');
      };
      posterImage.onerror = function () {
        if (root) root.classList.add('is-vct-poster-error');
      };
      posterImage.src = poster;
    }

    function markMetadata() {
      video.dataset.roverVideoMetadata = 'true';
      if (root) root.classList.add('is-vct-media-metadata');
    }

    function markReady() {
      if (video.readyState < 2) return;
      video.dataset.roverVideoReady = 'true';
      if (root) root.classList.add('is-vct-media-ready');
    }

    if (video.dataset.roverVideoReadyBound !== 'true') {
      video.dataset.roverVideoReadyBound = 'true';
      video.addEventListener('loadedmetadata', markMetadata, { once: true });
      ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
        video.addEventListener(eventName, markReady, { once: true });
      });
      video.addEventListener('error', function () {
        if (root) root.classList.add('is-vct-media-error');
      }, { once: true });
    }

    if (video.readyState >= 1) markMetadata();
    if (video.readyState >= 2) markReady();
    if (video.dataset.roverVideoPrepared === 'true') {
      if (shouldUpgradePreload || sourcesChanged) {
        try { video.load(); } catch (error) {}
      }
      return;
    }
    video.dataset.roverVideoPrepared = 'true';
    if (sourcesChanged || video.networkState === 0) {
      try { video.load(); } catch (error) {}
    }
  }

  function normalizeShopifyVideoUrl(url) {
    if (!url) return '';
    var value = String(url);
    if (value.indexOf('//') === 0) value = window.location.protocol + value;

    try {
      var parsed = new URL(value, window.location.href);
      var videoPath = parsed.pathname;
      var customCdnMarker = '/cdn/shop/videos/';

      if (videoPath.indexOf(customCdnMarker) !== -1) {
        return 'https://cdn.shopify.com/videos/' + videoPath.split(customCdnMarker).pop();
      }

      if (parsed.hostname === 'cdn.shopify.com' && videoPath.indexOf('/videos/') === 0) {
        return 'https://cdn.shopify.com' + videoPath;
      }
    } catch (error) {}

    return value;
  }

  function normalizeVideoElementSources(video) {
    if (!video || video.dataset.roverCanonicalizedVideo === 'true') return false;

    var changed = false;
    var currentSrc = video.getAttribute('src');
    var normalizedVideoSrc = normalizeShopifyVideoUrl(currentSrc);

    if (currentSrc && normalizedVideoSrc && normalizedVideoSrc !== currentSrc) {
      video.setAttribute('src', normalizedVideoSrc);
      changed = true;
    }

    video.querySelectorAll('source').forEach(function (source) {
      var sourceSrc = source.getAttribute('src');
      var normalizedSourceSrc = normalizeShopifyVideoUrl(sourceSrc);

      if (sourceSrc && normalizedSourceSrc && normalizedSourceSrc !== sourceSrc) {
        source.setAttribute('src', normalizedSourceSrc);
        changed = true;
      }
    });

    video.dataset.roverCanonicalizedVideo = 'true';
    if (changed) video.dataset.roverCanonicalVideo = 'true';
    return changed;
  }

  function getVideoSourceUrl(video) {
    if (!video) return '';
    var matchingSource = null;
    Array.prototype.slice.call(video.querySelectorAll('source')).some(function (source) {
      var media = source.getAttribute('media');
      if (!media || !window.matchMedia || window.matchMedia(media).matches) {
        matchingSource = source;
        return true;
      }
      return false;
    });
    return normalizeShopifyVideoUrl(video.currentSrc || video.getAttribute('src') || (matchingSource && matchingSource.src) || (video.querySelector('source') && video.querySelector('source').src) || '');
  }

  function addVideoPreloadHint(url, priority) {
    if (!url || !document.head) return;

    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.protocol !== 'https:') return;

      var preconnectKey = 'rover-preconnect-' + parsed.origin;
      if (!document.querySelector('link[data-rover-video-hint="' + preconnectKey + '"]')) {
        var preconnect = document.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = parsed.origin;
        preconnect.crossOrigin = 'anonymous';
        preconnect.setAttribute('data-rover-video-hint', preconnectKey);
        document.head.appendChild(preconnect);
      }

      if (priority !== 'high') return;

      var preloadKey = 'rover-preload-' + parsed.href;
      if (document.querySelector('link[data-rover-video-hint="' + preloadKey.replace(/"/g, '%22') + '"]')) return;
      var preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'video';
      preload.href = parsed.href;
      preload.type = 'video/mp4';
      preload.crossOrigin = 'anonymous';
      if ('fetchPriority' in preload) preload.fetchPriority = 'low';
      preload.setAttribute('data-rover-video-hint', preloadKey.replace(/"/g, '%22'));
      document.head.appendChild(preload);
    } catch (error) {}
  }

  function rangePrewarmVideo(video, byteLength) {
    if (!video || video.dataset.roverRangePrewarmed === 'true' || !window.fetch) return;
    var url = getVideoSourceUrl(video);
    if (!url) return;
    video.dataset.roverRangePrewarmed = 'true';

    var endByte = Math.max(1023, (byteLength || 131072) - 1);
    try {
      fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'force-cache',
        headers: { Range: 'bytes=0-' + endByte }
      }).catch(function () {
        try {
          fetch(url, { method: 'GET', mode: 'no-cors', credentials: 'omit', cache: 'force-cache' }).catch(function () {});
        } catch (fallbackError) {}
      });
    } catch (error) {}
  }

  function shouldPlayVideo(video) {
    if (!video || isHiddenMedia(video)) return false;
    var perspective = video.closest('[data-rover-perspective]');
    if (perspective) {
      return perspective.classList.contains('is-vct-playing') || perspective.classList.contains('is-vct-expanded') || perspective.classList.contains('is-mobile-vct-expanded');
    }
    return true;
  }

  function attemptVideoPlay(video) {
    if (!shouldPlayVideo(video)) return;
    if (video.dataset.roverPlayInFlight === 'true') return;
    if (!video.paused && !video.ended) {
      video.dataset.roverPendingPlay = 'false';
      return;
    }
    try {
      var playRequest = video.play();
      if (playRequest && playRequest.then) {
        video.dataset.roverPlayInFlight = 'true';
        playRequest.then(function () {
          video.dataset.roverPendingPlay = 'false';
          video.dataset.roverPlayInFlight = 'false';
        }).catch(function () {
          video.dataset.roverPlayInFlight = 'false';
        });
      }
    } catch (error) {
      video.dataset.roverPlayInFlight = 'false';
    }
  }

  function bindPendingVideoPlay(video) {
    if (!video || video.dataset.roverPendingPlayBound === 'true') return;
    video.dataset.roverPendingPlayBound = 'true';
    ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
      video.addEventListener(eventName, function () {
        if (video.dataset.roverPendingPlay === 'true') attemptVideoPlay(video);
      });
    });
  }

  function playPreparedVideo(video) {
    if (!video || prefersReducedMotion()) return;
    /* Data Saver: the viewport gate (shouldAutoplayViewportVideo) already refuses
       to autoplay, but the VCT/tabs/specs paths call this directly and previously
       ignored the flag, so a save-data viewer still got automatic playback.
       Explicit user intent goes through playVideoFromUser(), which bypasses here. */
    if (isDataSaverEnabled()) return;
    if (video.dataset.roverUserPaused === 'true') return;
    prepareVideo(video, 'auto');
    bindPendingVideoPlay(video);
    video.dataset.roverPendingPlay = 'true';
    if (!video.currentSrc || video.networkState === 0) {
      try { video.load(); } catch (error) {}
    }
    attemptVideoPlay(video);
  }

  function pauseVideo(video) {
    if (!video) return;
    video.dataset.roverPendingPlay = 'false';
    video.pause();
  }

  /* Rover 2026-09-23: inline video play/pause affordance.
     The inline media surfaces (statement / specs / ai-tabs / split) ship with
     controls=false and no manual entry point, so a viewer whose playback is
     suppressed (prefers-reduced-motion, or Data Saver) previously saw a frozen
     poster with no way to start it. Labels mirror the theme's existing
     general.accessibility.play_video strings; the accessible name stays constant
     and aria-pressed carries the state. */
  var ROVER_PLAY_TOGGLE_LABELS = {
    'ar': '\u062a\u0634\u063a\u064a\u0644 \u0627\u0644\u0641\u064a\u062f\u064a\u0648',
    'cs': 'P\u0159ehr\u00e1t video',
    'da': 'Afspil video',
    'de': 'Video abspielen',
    'el': '\u0391\u03bd\u03b1\u03c0\u03b1\u03c1\u03b1\u03b3\u03c9\u03b3\u03ae \u03b2\u03af\u03bd\u03c4\u03b5\u03bf',
    'en': 'Play video',
    'es': 'Reproducir v\u00eddeo',
    'fi': 'Toista video',
    'fr': 'Lire la vid\u00e9o',
    'he': '\u05d4\u05e4\u05e2\u05dc\u05ea \u05e1\u05e8\u05d8\u05d5\u05df',
    'it': 'Riproduci video',
    'ja': '\u52d5\u753b\u3092\u518d\u751f\u3059\u308b',
    'ko': '\ube44\ub514\uc624 \uc7ac\uc0dd',
    'lt': 'Leisti vaizdo \u012fra\u0161\u0105',
    'lv': 'Atska\u0146ot videoklipu',
    'nb': 'Spill av video',
    'nl': 'Video afspelen',
    'pl': 'Odtw\u00f3rz wideo',
    'pt-br': 'Reproduzir v\u00eddeo',
    'pt-pt': 'Play video',
    'ro': 'Red\u0103 videoclipul',
    'ru': '\u0421\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0432\u0438\u0434\u0435\u043e',
    'sk': 'Prehra\u0165 video',
    'sl': 'Predvajaj videoposnetek',
    'sv': 'Spela upp video',
    'tr': 'Videoyu oynat',
    'uk': '\u0412\u0456\u0434\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u0432\u0456\u0434\u0435\u043e',
    'zh-cn': '\u64ad\u653e\u89c6\u9891',
    'zh-tw': '\u64ad\u653e\u5f71\u7247'
  };

  function roverPlayToggleLabel() {
    var lang = (document.documentElement && document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    if (ROVER_PLAY_TOGGLE_LABELS[lang]) return ROVER_PLAY_TOGGLE_LABELS[lang];
    var primary = lang.split('-')[0];
    return ROVER_PLAY_TOGGLE_LABELS[primary] || ROVER_PLAY_TOGGLE_LABELS.en;
  }

  function getRoverInlineVideoHost(video) {
    if (!video || !video.closest) return null;
    if (video.closest('[data-rover-watch-film-modal], .rover-watch-film-modal')) return null;
    if (video.classList && video.classList.contains('rover-watch-film-modal__video')) return null;
    var section = video.closest('.rover-section');
    if (!section || section.classList.contains('rover-hero')) return null;
    return video.closest('.rover-statement__window, .rover-specs__media-panel, .rover-ai-tabs__media, .rover-split__media-panel');
  }

  function syncRoverPlayToggle(button, video) {
    if (!button || !video) return;
    button.setAttribute('aria-pressed', (!video.paused && !video.ended) ? 'true' : 'false');
  }

  function playVideoFromUser(video) {
    if (!video) return;
    // Explicit user intent: clear the sticky pause marker and bypass the
    // reduced-motion autoplay guard that playPreparedVideo() applies.
    delete video.dataset.roverUserPaused;
    prepareVideo(video, 'auto');
    bindPendingVideoPlay(video);
    video.dataset.roverPendingPlay = 'true';
    if (!video.currentSrc || video.networkState === 0) {
      try { video.load(); } catch (error) {}
    }
    try {
      var playRequest = video.play();
      if (playRequest && playRequest.catch) playRequest.catch(function () {});
    } catch (error) {}
  }

  function initVideoPlayToggles(scope) {
    var currentScope = scope || document;
    var videos = [];
    if (currentScope.matches && currentScope.matches('.rover-section video')) videos.push(currentScope);
    if (currentScope.querySelectorAll) {
      videos = videos.concat(Array.prototype.slice.call(currentScope.querySelectorAll('.rover-section video')));
    }

    videos.forEach(function (video) {
      var host = getRoverInlineVideoHost(video);
      if (!host || host.dataset.roverPlayToggleBound === 'true') return;
      host.dataset.roverPlayToggleBound = 'true';

      var button = host.querySelector('[data-rover-play-toggle]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'rover-video-toggle';
        button.setAttribute('data-rover-play-toggle', '');
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', roverPlayToggleLabel());
        button.innerHTML = '<span class="rover-video-toggle__icon" aria-hidden="true"></span>';
        host.appendChild(button);
      }

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (video.paused || video.ended) {
          playVideoFromUser(video);
        } else {
          video.dataset.roverUserPaused = 'true';
          pauseVideo(video);
        }
        syncRoverPlayToggle(button, video);
      });

      ['play', 'pause', 'ended', 'loadedmetadata', 'emptied'].forEach(function (eventName) {
        video.addEventListener(eventName, function () { syncRoverPlayToggle(button, video); });
      });

      syncRoverPlayToggle(button, video);
    });
  }

  function isDataSaverEnabled() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(connection && connection.saveData);
  }

  function isRoverViewportVideo(video) {
    if (!video || !video.closest || !video.closest('.rover-section')) return false;
    if (video.closest('[data-rover-watch-film-modal], .rover-watch-film-modal')) return false;
    return !video.classList || !video.classList.contains('rover-watch-film-modal__video');
  }

  function getVideoPlaybackTarget(video) {
    if (!video || !video.closest) return video;
    return video.closest('[data-rover-split-media], [data-rover-spec-media], [data-rover-panel]') ||
      video.closest('.rover-split__media, .rover-specs__media, .rover-ai-tabs__media') ||
      video;
  }

  function getUsableMediaRect(element) {
    if (!element || !element.getBoundingClientRect) return { width: 0, height: 0, top: 0, bottom: 0 };
    var rect = element.getBoundingClientRect();
    if (rect.width > 1 && rect.height > 1) return rect;
    if (element.querySelector) {
      var media = element.querySelector('video, img, picture');
      if (media && media.getBoundingClientRect) {
        var mediaRect = media.getBoundingClientRect();
        if (mediaRect.width > 1 && mediaRect.height > 1) return mediaRect;
      }
    }
    return rect;
  }

  function isRenderableMedia(element) {
    if (!element || isHiddenMedia(element)) return false;
    var node = element;
    while (node && node.nodeType === 1) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || style.contentVisibility === 'hidden') return false;
      }
      if (node.classList && node.classList.contains('rover-section')) break;
      node = node.parentElement;
    }
    var rect = getUsableMediaRect(element);
    return rect.width > 1 && rect.height > 1;
  }

  function isActiveVideoPanel(video) {
    if (!video || !video.closest) return false;

    var tabPanel = video.closest('[data-rover-panel]');
    if (tabPanel && (tabPanel.hidden || tabPanel.getAttribute('aria-hidden') === 'true')) return false;

    var specPanel = video.closest('[data-rover-spec-media]');
    if (specPanel && (specPanel.hidden || !specPanel.classList.contains('is-active'))) return false;

    var splitPanel = video.closest('[data-rover-split-media]');
    if (splitPanel && (splitPanel.hidden || !splitPanel.classList.contains('is-active'))) return false;

    return true;
  }

  function isVideoInPlaybackViewport(video) {
    if (!video) return false;
    var target = getVideoPlaybackTarget(video);
    var rect = getUsableMediaRect(target || video);
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    return rect.top < viewportHeight * 1.05 && rect.bottom > viewportHeight * -0.05;
  }

  function shouldAutoplayViewportVideo(video) {
    if (prefersReducedMotion() || isDataSaverEnabled()) return false;
    if (video.dataset.roverUserPaused === 'true') return false;
    if (!isRoverViewportVideo(video) || !isActiveVideoPanel(video) || !isRenderableMedia(video)) return false;
    if (!isVideoInPlaybackViewport(video)) return false;
    return shouldPlayVideo(video);
  }

  function getRoverViewportVideos(scope) {
    var currentScope = scope || document;
    var videos = [];
    if (currentScope.matches && currentScope.matches('video')) videos.push(currentScope);
    if (currentScope.querySelectorAll) {
      videos = videos.concat(Array.prototype.slice.call(currentScope.querySelectorAll('.rover-section video')));
    }
    return videos.filter(isRoverViewportVideo);
  }

  function syncVisibleVideoPlayback(scope) {
    getRoverViewportVideos(scope || document).forEach(function (video) {
      if (shouldAutoplayViewportVideo(video)) {
        playPreparedVideo(video);
      } else {
        pauseVideo(video);
      }
    });
  }

  function scheduleVisibleVideoPlaybackSync(scope) {
    var targetScope = scope || document;
    if (window.__roverVisibleVideoSyncFrame) window.cancelAnimationFrame(window.__roverVisibleVideoSyncFrame);
    window.__roverVisibleVideoSyncFrame = window.requestAnimationFrame(function () {
      window.__roverVisibleVideoSyncFrame = 0;
      syncVisibleVideoPlayback(targetScope);
    });
  }

  function initVisibleVideoPlayback(scope) {
    var currentScope = scope || document;
    var videos = getRoverViewportVideos(currentScope);
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      syncVisibleVideoPlayback(currentScope);
    } else {
      if (!window.__roverVisibleVideoObserver) {
        window.__roverVisibleVideoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && shouldAutoplayViewportVideo(video)) {
              playPreparedVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        }, { rootMargin: '180px 0px 160px 0px', threshold: [0, 0.01, 0.1, 0.35, 0.65] });
      }

      if (!window.__roverVisibleVideoContainerObserver) {
        window.__roverVisibleVideoContainerObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) scheduleVisibleVideoPlaybackSync(entry.target);
          });
        }, { rootMargin: '180px 0px 160px 0px', threshold: [0, 0.01, 0.1, 0.35] });
      }

      videos.forEach(function (video) {
        if (video.dataset.roverVisibleVideoObserved !== 'true') {
          video.dataset.roverVisibleVideoObserved = 'true';
          window.__roverVisibleVideoObserver.observe(video);
        }

        var playbackTarget = getVideoPlaybackTarget(video);
        if (playbackTarget && playbackTarget.dataset && playbackTarget.dataset.roverVisibleVideoTargetObserved !== 'true') {
          playbackTarget.dataset.roverVisibleVideoTargetObserved = 'true';
          window.__roverVisibleVideoContainerObserver.observe(playbackTarget);
        }
      });
    }

    if (window.__roverVisibleVideoEventsBound !== 'true') {
      window.__roverVisibleVideoEventsBound = 'true';
      window.addEventListener('resize', function () { scheduleVisibleVideoPlaybackSync(document); }, { passive: true });
      window.addEventListener('orientationchange', function () { scheduleVisibleVideoPlaybackSync(document); }, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          getRoverViewportVideos(document).forEach(pauseVideo);
        } else {
          scheduleVisibleVideoPlaybackSync(document);
        }
      });
    }

    scheduleVisibleVideoPlaybackSync(currentScope);
  }

  function isHiddenMedia(element) {
    return !element || !!element.closest('[hidden], [aria-hidden="true"]');
  }

  function getPanelById(panels, attr, id) {
    return panels.find(function (panel) {
      return panel.getAttribute(attr) === id;
    });
  }

  function prewarmVideo(video) {
    if (!video) return;
    var isCriticalVideo = video.hasAttribute('data-rover-critical-video') || !!video.closest('[data-rover-perspective]');
    var preloadMode = isCriticalVideo ? 'auto' : (video.getAttribute('preload') || 'metadata');
    prepareVideo(video, preloadMode);
    video.dataset.roverPrewarmed = 'true';
    if (isCriticalVideo) {
      addVideoPreloadHint(getVideoSourceUrl(video), 'low');
      rangePrewarmVideo(video, 196608);
    }
  }


  function aggressivePreloadRoverVideo(video) {
    if (!video || video.dataset.roverAggressivePreload === 'true') return;
    video.dataset.roverAggressivePreload = 'true';
    prepareVideo(video, 'auto');
    video.preload = 'auto';
    addVideoPreloadHint(getVideoSourceUrl(video), 'low');
    rangePrewarmVideo(video, 1048576);
    try { video.load(); } catch (error) {}
  }

  function initRoverAllVideoPreload(scope) {
    var currentScope = scope || document;
    if (!currentScope.querySelector || !currentScope.querySelector('.rover-section')) return;
    if (window.__roverAllVideoPreloadBound === 'true') return;
    window.__roverAllVideoPreloadBound = 'true';

    /* Rover 2026-09-23: converge prewarming. Previously every video on the page
       was forced to preload="auto" and fired a 1 MB range request during idle,
       which put 16 parallel fetches in flight and competed with the first
       viewport video the user actually reached. Now only sections within ~1.5
       viewports are prewarmed; the rest keep preload="metadata" until
       playPreparedVideo() upgrades them on approach. */
    var run = function () {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      document.querySelectorAll('.rover-section video').forEach(function (video) {
        var section = video.closest('.rover-section');
        if (!section) return;
        var rect = section.getBoundingClientRect();
        if (rect.top > viewportHeight * 1.5) return;
        if (rect.bottom < viewportHeight * -0.5) return;
        aggressivePreloadRoverVideo(video);
      });
    };

    var schedule = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
      } else {
        window.setTimeout(run, 600);
      }
    };

    /* Re-evaluate on scroll so a section that becomes near-viewport while the
       visitor scrolls is prewarmed before its video is asked to play; otherwise
       playback would start from a cold buffer again. aggressivePreloadRoverVideo
       is idempotent per video, so repeat passes are cheap. */
    var syncFrame = 0;
    var scheduleOnScroll = function () {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = 0;
        run();
      });
    };

    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
      window.setTimeout(schedule, 3200);
    }

    window.addEventListener('scroll', scheduleOnScroll, { passive: true });
    window.addEventListener('resize', scheduleOnScroll, { passive: true });
    window.addEventListener('orientationchange', scheduleOnScroll, { passive: true });
  }

  function prewarmPanelMedia(panel) {
    if (!panel) return;
    panel.querySelectorAll('video').forEach(prewarmVideo);
  }

  function canPlaySectionMedia(root) {
    if (!root) return false;
    var rect = root.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    return rect.top < viewportHeight * 1.05 && rect.bottom > viewportHeight * -0.15;
  }

  function prewarmPrimaryMedia(root) {
    if (!root) return;
    root.classList.add('is-rover-media-prewarmed');

    if (root.matches('[data-rover-specs]')) {
      prewarmPanelMedia(root.querySelector('.rover-specs__media-panel.is-active') || root.querySelector('[data-rover-spec-media]'));
      return;
    }

    if (root.matches('[data-rover-tabs]')) {
      prewarmPanelMedia(root.querySelector('.rover-ai-tabs__media-panel.is-active') || root.querySelector('[data-rover-panel]'));
      return;
    }

    if (root.matches('.rover-split')) {
      root.querySelectorAll('[data-rover-split-row]').forEach(function (row) {
        prewarmPanelMedia(row.querySelector('.rover-split__media-panel.is-active') || row.querySelector('[data-rover-split-media]'));
      });
      return;
    }

    Array.prototype.slice.call(root.querySelectorAll('video')).some(function (video) {
      if (isHiddenMedia(video)) return false;
      prewarmVideo(video);
      return true;
    });
  }

  function markRoverTemplate(scope) {
    if ((scope || document).querySelector('.rover-section')) {
      document.documentElement.classList.add('rover-template-active');
      document.documentElement.classList.add('rover-js-active');
    }
  }

  function initHeroLoad(scope) {
    var roots = [];
    if (scope.matches && scope.matches('.rover-hero')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('.rover-hero')));

    roots.forEach(function (root) {
      if (root.dataset.roverHeroLoadBound === 'true') return;
      root.dataset.roverHeroLoadBound = 'true';

      var compact = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var selector = compact ? '.rover-hero__mobile-visual' : '.rover-hero__viewport-bg img, .rover-hero__glasses-main, .rover-hero__glasses-float';
      var images = Array.prototype.slice.call(root.querySelectorAll(selector)).filter(function (image) {
        return image && image.getAttribute('src');
      });

      var marked = false;
      function markReady() {
        if (marked) return;
        marked = true;
        root.classList.remove('is-hero-loading');
        root.classList.add('is-hero-ready');
      }

      if (!images.length) {
        markReady();
        return;
      }

      root.classList.add('is-hero-loading');
      var remaining = images.length;

      function imageDone() {
        remaining -= 1;
        if (remaining <= 0) markReady();
      }

      images.forEach(function (image) {
        if (image.complete && image.naturalWidth > 0) {
          if (image.decode) {
            image.decode().then(imageDone).catch(imageDone);
          } else {
            imageDone();
          }
          return;
        }

        image.addEventListener('load', imageDone, { once: true });
        image.addEventListener('error', imageDone, { once: true });
      });

      window.setTimeout(markReady, 2200);
    });
  }

  function hideElement(element) {
    if (!element || element.dataset.roverSuppressed === 'true') return;
    element.dataset.roverSuppressed = 'true';
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
    if (document.body && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  }

  function suppressMarketingOverlays(scope) {
    if (!document.documentElement.classList.contains('rover-template-active')) return;

    var roots = [document.body];
    if (scope && scope !== document && scope.nodeType === 1) roots.push(scope);

    roots.forEach(function (root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll('yg-popup-box.yg-popup-box').forEach(hideElement);
      root.querySelectorAll('shopify-chat, #shopify-chat, [id^="ShopifyChat"], [class*="shopify-chat"]').forEach(hideElement);

      root.querySelectorAll('div, section, aside, dialog').forEach(function (element) {
        var text = (element.innerText || element.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (/New product drop|Limited Early-Bird Offer|Subscribe Now and Stay Tuned/i.test(text)) {
          hideElement(element.closest('[role="dialog"], [aria-modal="true"], .needsclick, .yg-popup-box, dialog') || element);
        }
      });
    });
  }

  function initOverlaySuppression(scope) {
    markRoverTemplate(scope || document);
    suppressMarketingOverlays(scope || document);

    if (!document.documentElement.classList.contains('rover-template-active') || window.__roverOverlayObserver) return;

    window.__roverOverlayObserver = new MutationObserver(function () {
      suppressMarketingOverlays(document);
    });
    window.__roverOverlayObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initTabs(scope) {
    var roots = scope.querySelectorAll('[data-rover-tabs]');

    roots.forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rover-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rover-panel]'));
      var copyPanels = Array.prototype.slice.call(root.querySelectorAll('[data-rover-copy-panel]'));

      if (root.dataset.roverTabsBound === 'true') return;
      root.dataset.roverTabsBound = 'true';

      panels.forEach(function (panel) {
        panel.querySelectorAll('video').forEach(function (video) {
          prepareVideo(video, 'metadata');
        });
      });

      if ('IntersectionObserver' in window) {
        var prewarmObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            prewarmPrimaryMedia(root);
            observer.unobserve(root);
          });
        }, { rootMargin: '1200px 0px 900px 0px', threshold: 0.01 });
        prewarmObserver.observe(root);
      }

      function activate(id, playActive) {
        var allowPlayback = playActive !== false && canPlaySectionMedia(root);

        tabs.forEach(function (tab) {
          var active = tab.getAttribute('data-rover-tab') === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-rover-panel') === id;
          panel.toggleAttribute('hidden', !active);
          panel.querySelectorAll('video').forEach(function (video) {
            if (active && allowPlayback) {
              prepareVideo(video, 'auto');
              playPreparedVideo(video);
            } else if (active) {
              prepareVideo(video, 'metadata');
            } else {
              pauseVideo(video);
            }
          });
        });

        copyPanels.forEach(function (panel) {
          var active = panel.getAttribute('data-rover-copy-panel') === id;
          panel.toggleAttribute('hidden', !active);
        });

        scheduleVisibleVideoPlaybackSync(root);
      }

      tabs.forEach(function (tab, index) {
        function prewarmTab() {
          var panel = getPanelById(panels, 'data-rover-panel', tab.getAttribute('data-rover-tab'));
          prewarmPanelMedia(panel);
        }

        /* Switch on hover. The old guard required matchMedia('(hover:hover) and
           (pointer:fine)'), which some hybrid laptops/touch-screens report as false, so the
           hover switch silently never fired there. Pointer type is the reliable signal:
           mouse/pen hover switches, touch is ignored (tap still uses the click handler). */
        tab.addEventListener('pointerenter', function (event) {
          prewarmTab();
          var pointerType = event && event.pointerType ? event.pointerType : 'mouse';
          if (pointerType !== 'touch' && !tab.classList.contains('is-active')) {
            activate(tab.getAttribute('data-rover-tab'), true);
          }
        });
        tab.addEventListener('focus', prewarmTab);

        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-rover-tab'), true);
        });

        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var next = tabs[(index + direction + tabs.length) % tabs.length];
          next.focus();
          activate(next.getAttribute('data-rover-tab'), true);
        });
      });

      var activeTab = tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0];
      if (activeTab) activate(activeTab.getAttribute('data-rover-tab'), false);
      prewarmPrimaryMedia(root);
    });
  }

  function initSpecsMedia(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-specs]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-specs]')));

    roots.forEach(function (root) {
      if (root.dataset.roverSpecsBound === 'true') return;
      root.dataset.roverSpecsBound = 'true';

      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-rover-spec-trigger]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rover-spec-media]'));
      var detailPanels = Array.prototype.slice.call(root.querySelectorAll('[data-rover-spec-detail]'));
      if (!triggers.length || !panels.length) return;

      panels.forEach(function (panel) {
        panel.querySelectorAll('img').forEach(function (image) {
          var src = image.currentSrc || image.getAttribute('src');
          if (!src || image.dataset.roverSpecPreloaded === 'true') return;
          image.dataset.roverSpecPreloaded = 'true';
          var preload = new Image();
          preload.src = src;
        });
        panel.querySelectorAll('video').forEach(function (video) {
          prepareVideo(video, 'metadata');
        });
      });

      function prewarmSpecTrigger(trigger) {
        var panel = getPanelById(panels, 'data-rover-spec-media', trigger.getAttribute('data-rover-spec-trigger'));
        prewarmPanelMedia(panel);
      }

      function activate(id, playActive) {
        var allowPlayback = playActive !== false && canPlaySectionMedia(root);

        triggers.forEach(function (trigger) {
          var active = trigger.getAttribute('data-rover-spec-trigger') === id;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-rover-spec-media') === id;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);

          panel.querySelectorAll('video').forEach(function (video) {
            if (active && allowPlayback) {
              playPreparedVideo(video);
            } else if (active) {
              prepareVideo(video, 'metadata');
            } else {
              pauseVideo(video);
            }
          });
        });

        detailPanels.forEach(function (panel) {
          var active = panel.getAttribute('data-rover-spec-detail') === id;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });

        scheduleVisibleVideoPlaybackSync(root);
      }

      triggers.forEach(function (trigger, index) {
        function activateCurrentTrigger() {
          prewarmSpecTrigger(trigger);
          activate(trigger.getAttribute('data-rover-spec-trigger'), true);
        }

        trigger.addEventListener('click', function () {
          activateCurrentTrigger();
        });

        trigger.addEventListener('mouseenter', function () {
          if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
          activateCurrentTrigger();
        });

        trigger.addEventListener('focus', function () {
          activateCurrentTrigger();
        });

        trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var next = triggers[(index + direction + triggers.length) % triggers.length];
          next.focus();
          activate(next.getAttribute('data-rover-spec-trigger'), true);
        });
      });

      var activeTrigger = triggers.find(function (trigger) { return trigger.classList.contains('is-active'); }) || triggers[0];
      if (activeTrigger) activate(activeTrigger.getAttribute('data-rover-spec-trigger'), false);
      prewarmPrimaryMedia(root);
    });
  }

  function initSplitAccordions(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-split-accordion]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-split-accordion]')));

    roots.forEach(function (root) {
      if (root.dataset.roverSplitAccordionBound === 'true') return;
      root.dataset.roverSplitAccordionBound = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-rover-split-accordion-item]'));
      var row = root.closest('[data-rover-split-row]');
      var mediaPanels = row ? Array.prototype.slice.call(row.querySelectorAll('[data-rover-split-media]')) : [];
      if (!items.length) return;

      mediaPanels.forEach(function (panel) {
        panel.querySelectorAll('video').forEach(function (video) {
          prepareVideo(video, 'metadata');
        });
      });

      function activateMedia(item, playActive) {
        if (!mediaPanels.length || !item) return;
        var id = item.getAttribute('data-rover-split-media-trigger');
        var allowPlayback = playActive !== false && canPlaySectionMedia(row || root);
        mediaPanels.forEach(function (panel) {
          var active = panel.getAttribute('data-rover-split-media') === id;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
          panel.querySelectorAll('video').forEach(function (video) {
            if (active && allowPlayback) {
              playPreparedVideo(video);
            } else if (active) {
              prepareVideo(video, 'metadata');
            } else {
              pauseVideo(video);
            }
          });
        });

        scheduleVisibleVideoPlaybackSync(row || root);
      }

      function syncState(playActive) {
        var openItem = items.find(function (item) { return item.open; }) || items[0];
        items.forEach(function (item) {
          var summary = item.querySelector('summary');
          item.classList.toggle('is-open', item.open);
          if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        });
        activateMedia(openItem, playActive);
      }

      items.forEach(function (item) {
        var summary = item.querySelector('summary');

        if (summary) {
          summary.addEventListener('pointerenter', function () {
            var panel = getPanelById(mediaPanels, 'data-rover-split-media', item.getAttribute('data-rover-split-media-trigger'));
            prewarmPanelMedia(panel);
          });

          summary.addEventListener('focus', function () {
            var panel = getPanelById(mediaPanels, 'data-rover-split-media', item.getAttribute('data-rover-split-media-trigger'));
            prewarmPanelMedia(panel);
          });

          summary.addEventListener('click', function (event) {
            if (item.open) {
              event.preventDefault();
              syncState(true);
              return;
            }

            items.forEach(function (sibling) {
              if (sibling !== item) sibling.open = false;
            });
            window.requestAnimationFrame(function () { syncState(true); });
          });
        }

        item.addEventListener('toggle', function () {
          if (item.open) {
            items.forEach(function (sibling) {
              if (sibling !== item) sibling.open = false;
            });
          }
          syncState(true);
        });
      });

      var firstOpen = items.find(function (item) { return item.open; });
      if (!firstOpen) firstOpen = items[0];
      if (firstOpen) firstOpen.open = true;
      items.forEach(function (item) { if (item !== firstOpen) item.open = false; });
      syncState(false);
      if (row) prewarmPrimaryMedia(row.closest('.rover-split') || row);
    });
  }

  function initFaqAccordions(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-faq]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-faq]')));

    roots.forEach(function (root) {
      if (root.dataset.roverFaqBound === 'true') return;
      root.dataset.roverFaqBound = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('.rover-faq__list details'));
      if (!items.length) return;

      function syncState() {
        items.forEach(function (item) {
          var summary = item.querySelector('summary');
          item.classList.toggle('is-open', item.open);
          if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        });
      }

      function setOpen(item, open) {
        if (!item) return;
        item.open = open;
        item.classList.toggle('is-open', open);
        if (open) item.classList.remove('is-closing');
        var summary = item.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function closeItem(item) {
        if (!item || !item.open) {
          setOpen(item, false);
          return;
        }
        item.classList.add('is-closing');
        var answer = item.querySelector('.rover-faq__answer');
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var finished = false;

        /* Commit the native <details> close only when the 0fr row transition has really
           ended. The old fixed 360ms timer lost the race on slower frames, so the content
           was hidden mid-animation and the collapse visibly stuttered. */
        function finishClose() {
          if (finished) return;
          finished = true;
          if (answer) answer.removeEventListener('transitionend', onTransitionEnd);
          if (!item.classList.contains('is-closing')) return;
          setOpen(item, false);
          item.classList.remove('is-closing');
        }

        function onTransitionEnd(event) {
          if (event.target !== answer) return;
          if (event.propertyName !== 'grid-template-rows') return;
          finishClose();
        }

        if (answer && !reduced) {
          answer.addEventListener('transitionend', onTransitionEnd);
          window.setTimeout(finishClose, 900);
        } else {
          finishClose();
        }
      }

      function toggleItem(item) {
        var shouldOpen = !item.open;
        items.forEach(function (sibling) {
          if (sibling !== item) closeItem(sibling);
        });
        if (shouldOpen) setOpen(item, true);
        else closeItem(item);
      }

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function (event) {
            event.preventDefault();
            toggleItem(item);
          });
        }

        item.addEventListener('toggle', syncState);
      });

      syncState();
    });
  }

  function initDisclosureScrollAnchors(scope) {
    var currentScope = scope || document;
    var controls = [];
    var selector = [
      '.rover-purchase-drawer summary',
      '.rover-purchase-drawer .custom-accordion-summary',
      '.rover-purchase-drawer [aria-expanded][aria-controls]'
    ].join(', ');

    function stabilizeControl(control, beforeTop) {
      var start = window.performance && window.performance.now ? window.performance.now() : Date.now();
      var duration = 380;
      var cancelled = false;
      var lastAppliedAt = 0;

      function cancel() {
        cancelled = true;
      }

      window.addEventListener('wheel', cancel, { passive: true, once: true });
      window.addEventListener('touchmove', cancel, { passive: true, once: true });
      window.addEventListener('keydown', cancel, { passive: true, once: true });

      function cleanup() {
        window.removeEventListener('wheel', cancel);
        window.removeEventListener('touchmove', cancel);
        window.removeEventListener('keydown', cancel);
      }

      function frame(now) {
        if (cancelled || !document.documentElement.contains(control)) {
          cleanup();
          return;
        }

        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        var afterTop = control.getBoundingClientRect().top;
        var delta = afterTop - beforeTop;
        /* Tall disclosures (compare is ~800px, AI split rows are ~500px) move the control
           much further than the old 0.75-viewport guard allowed, so the compensation was
           skipped and the page appeared to jump to another module. Keep a generous guard
           for runaway layout shifts only. */
        if (Math.abs(delta) > 1 && Math.abs(delta) < viewportHeight * 3) {
          window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
          lastAppliedAt = now;
        }

        if (now - start < duration || now - lastAppliedAt < 80) {
          window.requestAnimationFrame(frame);
        } else {
          cleanup();
        }
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(frame);
      });
    }

    if (currentScope.matches && currentScope.matches(selector)) controls.push(currentScope);
    controls = controls.concat(Array.prototype.slice.call(currentScope.querySelectorAll(selector)));

    controls.forEach(function (control) {
      if (control.dataset.roverScrollAnchorBound === 'true') return;
      control.dataset.roverScrollAnchorBound = 'true';

      control.addEventListener('click', function () {
        var beforeTop = control.getBoundingClientRect().top;
        stabilizeControl(control, beforeTop);
      });
    });
  }

  function initCompareTables(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-compare]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-compare]')));

    roots.forEach(function (root) {
      if (root.dataset.roverCompareBound === 'true') return;
      root.dataset.roverCompareBound = 'true';

      var toggle = root.querySelector('[data-rover-compare-toggle]');
      if (!toggle) return;
      var shell = root.querySelector('.rover-compare__table-shell');
      var table = root.querySelector('.rover-compare__table');
      var resizeObserver = null;

      function getNumber(value, fallback) {
        var parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      function updateCompareMetrics() {
        if (!shell || !table) return;
        var style = window.getComputedStyle(shell);
        var expandedPadding = getNumber(style.getPropertyValue('--rover-compare-expanded-pad'), 104);
        var expandedHeight = Math.ceil(table.getBoundingClientRect().height + expandedPadding);
        root.style.setProperty('--rover-compare-expanded-height', expandedHeight + 'px');
      }

      function setExpanded(expanded) {
        updateCompareMetrics();
        root.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setExpanded(!root.classList.contains('is-expanded'));
      });

      updateCompareMetrics();
      window.addEventListener('resize', updateCompareMetrics, { passive: true });

      if ('ResizeObserver' in window && table) {
        resizeObserver = new ResizeObserver(updateCompareMetrics);
        resizeObserver.observe(table);
      }

      setExpanded(root.dataset.startExpanded === 'true');
    });
  }

  function initScrollers(scope) {
    var tracks = scope.querySelectorAll('[data-rover-scroll-track]');

    tracks.forEach(function (track) {
      var root = track.closest('.rover-section__inner') || track.parentElement;
      if (!root) return;

      var prev = root.querySelector('[data-rover-scroll-prev]');
      var next = root.querySelector('[data-rover-scroll-next]');
      var firstCard = track.children[0];
      var step = firstCard ? firstCard.getBoundingClientRect().width + 12 : 312;

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      }
    });
  }

  function initDeferredMediaPreload(scope) {
    var roots = [];
    var currentScope = scope || document;

    var selector = '.rover-audio, .rover-feature-card--5, .rover-specs, [data-rover-tabs], .rover-split, [data-rover-perspective]';
    if (currentScope.matches && currentScope.matches(selector)) roots.push(currentScope);
    roots = roots.concat(Array.prototype.slice.call(currentScope.querySelectorAll(selector)));
    if (!roots.length) return;

    function preloadImage(image) {
      if (!image || image.dataset.roverDeferredPreload === 'true') return;
      var src = image.currentSrc || image.getAttribute('src');
      if (!src) return;

      image.dataset.roverDeferredPreload = 'true';
      var rect = image.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var isNearViewport = rect.top < viewportHeight * 1.25 && rect.bottom > -200;
      image.loading = isNearViewport ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.setAttribute('fetchpriority', isNearViewport ? 'low' : 'auto');

      if (image.complete && image.naturalWidth > 0) {
        image.classList.add('is-rover-media-ready');
        return;
      }

      image.addEventListener('load', function () {
        image.classList.add('is-rover-media-ready');
        if (image.decode) image.decode().catch(function () {});
      }, { once: true });
      image.addEventListener('error', function () {
        image.classList.add('is-rover-media-error');
      }, { once: true });
    }

    function preloadRoot(root) {
      if (!root) return;
      root.querySelectorAll('img').forEach(preloadImage);
      prewarmPrimaryMedia(root);
    }

    if (!('IntersectionObserver' in window)) {
      roots.forEach(preloadRoot);
      return;
    }

    if (!window.__roverDeferredMediaObserver) {
      window.__roverDeferredMediaObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          preloadRoot(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '520px 0px 520px 0px', threshold: 0.01 });
    }

    roots.forEach(function (root) {
      if (root.dataset.roverDeferredMediaBound === 'true') return;
      root.dataset.roverDeferredMediaBound = 'true';
      window.__roverDeferredMediaObserver.observe(root);
    });
  }

  function initPurchaseDrawer(scope) {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-rover-purchase-trigger]'));
    var drawers = Array.prototype.slice.call((scope || document).querySelectorAll('[data-rover-purchase-drawer]'));
    var activeDrawer = document.querySelector('[data-rover-purchase-drawer].is-open');
    var lastTrigger = null;

    function prewarmDrawerMedia(drawer) {
      if (!drawer || drawer.dataset.roverPurchaseMediaPrewarmed === 'true') return;
      drawer.dataset.roverPurchaseMediaPrewarmed = 'true';

      Array.prototype.slice.call(drawer.querySelectorAll('img')).forEach(function (image, index) {
        var src = image.currentSrc || image.getAttribute('src');
        if (!src) return;

        image.loading = 'eager';
        image.decoding = 'async';
        image.setAttribute('fetchpriority', index < 8 ? 'high' : 'low');

        var probe = new Image();
        var srcset = image.getAttribute('srcset');
        var sizes = image.getAttribute('sizes');
        probe.decoding = 'async';
        if (sizes) probe.sizes = sizes;
        if (srcset) probe.srcset = srcset;
        probe.src = src;
      });

      drawer.querySelectorAll('video').forEach(prewarmVideo);
    }

    function findDrawer(trigger) {
      var targetId = trigger.getAttribute('aria-controls');
      if (targetId) {
        var targeted = document.getElementById(targetId);
        if (targeted && targeted.matches('[data-rover-purchase-drawer]')) return targeted;
      }
      return document.querySelector('[data-rover-purchase-drawer]');
    }

    function openDrawer(drawer, trigger) {
      if (!drawer) return;
      if (drawer.hasAttribute('data-rover-purchase-design-mode')) return;
      activeDrawer = drawer;
      lastTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      prewarmDrawerMedia(drawer);
      document.documentElement.classList.add('rover-purchase-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var close = drawer.querySelector('.rover-purchase-drawer__close');
        if (close && close.focus) close.focus({ preventScroll: true });
      });
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      if (drawer.hasAttribute('data-rover-purchase-design-mode')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rover-purchase-drawer-open');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, prefersReducedMotion() ? 0 : 420);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
      if (activeDrawer === drawer) activeDrawer = null;
    }

    triggers.forEach(function (trigger) {
      if (trigger.dataset.roverPurchaseTriggerBound === 'true') return;
      trigger.dataset.roverPurchaseTriggerBound = 'true';
      trigger.addEventListener('click', function (event) {
        var drawer = findDrawer(trigger);
        if (!drawer) return;
        if (drawer.querySelector('[data-rover-purchase-restricted="true"], .is-market-restricted')) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        openDrawer(drawer, trigger);
      });
    });

    drawers.forEach(function (drawer) {
      if (drawer.dataset.roverPurchaseDrawerBound === 'true') return;
      drawer.dataset.roverPurchaseDrawerBound = 'true';
      drawer.querySelectorAll('[data-rover-purchase-close]').forEach(function (close) {
        close.addEventListener('click', function () {
          closeDrawer(drawer);
        });
      });
    });

    if (window.__roverPurchaseDrawerKeyBound !== 'true') {
      window.__roverPurchaseDrawerKeyBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer(activeDrawer || document.querySelector('[data-rover-purchase-drawer].is-open'));
      });
    }
  }

  function initWatchFilm(scope) {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-rover-watch-film]'));
    if (!triggers.length) return;
    var modal = document.querySelector('[data-rover-watch-film-modal]');
    var activeWatchFilmTrigger = null;

    function getModalVideo() {
      return modal ? modal.querySelector('video') : null;
    }

    function setModalOpen(open, trigger) {
      if (!modal) return false;
      var video = getModalVideo();
      if (open) {
        activeWatchFilmTrigger = trigger || document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('rover-watch-film-open');
        if (video) {
          normalizeVideoElementSources(video);
          video.controls = true;
          video.setAttribute('controls', 'controls');
          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.preload = 'auto';
          try { video.load(); } catch (error) {}
          try {
            var playRequest = video.play();
            if (playRequest && playRequest.catch) playRequest.catch(function () {});
          } catch (error) {}
        }
        window.requestAnimationFrame(function () { modal.classList.add('is-open'); });
        var closeButton = modal.querySelector('.rover-watch-film-modal__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
        return true;
      }

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rover-watch-film-open');
      if (video) {
        video.pause();
        try { video.currentTime = 0; } catch (error) {}
      }
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, prefersReducedMotion() ? 0 : 240);
      if (activeWatchFilmTrigger && activeWatchFilmTrigger.focus) activeWatchFilmTrigger.focus({ preventScroll: true });
      activeWatchFilmTrigger = null;
      return true;
    }

    if (modal && modal.dataset.roverWatchFilmModalBound !== 'true') {
      modal.dataset.roverWatchFilmModalBound = 'true';
      modal.addEventListener('click', function (event) {
        var closeTarget = event.target && event.target.closest ? event.target.closest('[data-rover-watch-film-close]') : null;
        var backdrop = event.target && event.target.closest ? event.target.closest('.rover-watch-film-modal__backdrop') : null;
        if (closeTarget || backdrop || event.target === modal) setModalOpen(false);
      });

      var modalVideo = getModalVideo();
      if (modalVideo) {
        normalizeVideoElementSources(modalVideo);
        modalVideo.preload = 'metadata';
      }
    }

    if (window.__roverWatchFilmKeyBound !== 'true') {
      window.__roverWatchFilmKeyBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var openModal = document.querySelector('[data-rover-watch-film-modal].is-open');
        if (openModal) setModalOpen(false);
      });
    }

    function findPerspective() {
      return document.querySelector('[data-rover-perspective]') || document.getElementById('rover-perspective');
    }

    triggers.forEach(function (trigger) {
      if (trigger.dataset.roverWatchFilmBound === 'true') return;
      trigger.dataset.roverWatchFilmBound = 'true';

      trigger.addEventListener('click', function (event) {
        if (modal) {
          event.preventDefault();
          setModalOpen(true, trigger);
          return;
        }

        var target = findPerspective();
        if (!target) return;
        event.preventDefault();

        var offset = 0;
        var header = document.querySelector('header, [data-sticky-header], .shopify-section-group-header-group');
        if (header) {
          var styles = window.getComputedStyle(header);
          var rect = header.getBoundingClientRect();
          if ((styles.position === 'fixed' || styles.position === 'sticky') && rect.bottom > 0) offset = Math.min(rect.bottom, (window.innerHeight || 1) * 0.24);
        }

        var rectTop = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
        window.scrollTo({ top: Math.max(0, rectTop - offset), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });

        window.setTimeout(function () {
          target.dispatchEvent(new CustomEvent('rover:perspective:watch', { bubbles: true }));
        }, prefersReducedMotion() ? 0 : 420);
      });
    });
  }

  function initRoverBundleSelectors(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-bundle-selector]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-bundle-selector]')));

    roots.forEach(function (root) {
      if (root.dataset.roverBundleSelectorBound === 'true') return;
      root.dataset.roverBundleSelectorBound = 'true';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rover-bundle-card]'));
      var addButton = root.querySelector('[data-rover-bundle-add]');
      var cardAddButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rover-bundle-card-add]'));
      var message = root.querySelector('[data-rover-bundle-message]');
      var selectedCard = cards.find(function (card) { return card.classList.contains('is-selected'); }) || cards[0];
      var isMarketRestricted = root.getAttribute('data-rover-purchase-restricted') === 'true';
      var marketRestrictedMessage = root.getAttribute('data-rover-restricted-message') || 'This product is not available for purchase in your region.';

      function getCurrentMainVariantId() {
        var formId = root.getAttribute('data-rover-product-form-id');
        var selectors = [];
        if (formId) {
          var escapedFormId = escapeSelector(formId);
          selectors.push('input[name="id"][form="' + escapedFormId + '"]');
          selectors.push('form#' + escapedFormId + ' input[name="id"]');
          selectors.push('#' + escapedFormId + ' input[name="id"]');
        }
        selectors.push('product-rerender input[name="id"]');
        selectors.push('input[name="id"]');

        for (var index = 0; index < selectors.length; index += 1) {
          var input = root.closest('product-rerender, .rover-purchase-drawer, body')?.querySelector(selectors[index]) || document.querySelector(selectors[index]);
          if (input && input.value) return String(input.value);
        }

        return '';
      }

      function getCardItems(card) {
        if (!card) return [];
        var script = card.querySelector('[data-rover-bundle-items]');
        if (!script) return [];

        try {
          var parsed = JSON.parse(script.textContent || '[]');
          var variantSelects = Array.prototype.slice.call(card.querySelectorAll('[data-rover-bundle-variant-select]'));
          var selectedVariantsByRole = {};

          variantSelects.forEach(function (select) {
            if ((select.type === 'radio' || select.type === 'checkbox') && !select.checked) return;
            var role = select.getAttribute('data-rover-bundle-variant-role');
            if (role && select.value) selectedVariantsByRole[role] = select.value;
          });

          var bundleVariant = getSelectedBundleVariant(card, selectedVariantsByRole);
          if (bundleVariant && bundleVariant.id) selectedVariantsByRole.bundle = bundleVariant.id;

          var mainVariantId = getCurrentMainVariantId();
          var mainProductId = String(root.getAttribute('data-rover-main-product-id') || '');

          return parsed.filter(function (item) {
            return item && item.id && Number(item.quantity || 1) > 0;
          }).map(function (item) {
            var role = item.role ? String(item.role) : '';
            if (role && selectedVariantsByRole[role]) item.id = selectedVariantsByRole[role];
            var itemProductId = item.productId ? String(item.productId) : '';
            if (role === 'bundle' && item.source !== 'explicit' && mainVariantId && itemProductId && itemProductId === mainProductId) item.id = mainVariantId;
            return item;
          }).map(function (item) {
            return {
              id: String(item.id),
              quantity: Number(item.quantity || 1),
              properties: {
                _rover_package: card.getAttribute('data-rover-bundle-title') || 'Rover package'
              }
            };
          });
        } catch (error) {
          return [];
        }
      }

      function getBundleVariantMap(card) {
        var mapScript = card ? card.querySelector('[data-rover-bundle-variant-map]') : null;
        if (!mapScript) return [];

        try {
          var variants = JSON.parse(mapScript.textContent || '[]');
          if (!Array.isArray(variants)) return [];
          var locallySoldOutVariantIds = card && card._roverBundleSoldOutVariantIds ? card._roverBundleSoldOutVariantIds : {};
          variants.forEach(function (variant) {
            if (variant && locallySoldOutVariantIds[String(variant.id)]) variant.available = false;
          });
          return variants;
        } catch (error) {
          return [];
        }
      }

      function getSelectedVariantControls(card) {
        var controls = Array.prototype.slice.call(card ? card.querySelectorAll('[data-rover-bundle-variant-select]') : []);
        var selected = {};

        controls.forEach(function (control) {
          if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
          var role = control.getAttribute('data-rover-bundle-variant-role');
          if (role) selected[role] = control;
        });

        return selected;
      }

      function getSelectedBundleVariant(card, selectedVariantsByRole) {
        var variants = getBundleVariantMap(card);
        if (!variants.length) return null;

        var selected = selectedVariantsByRole || {};
        var optionValues = [];

        Object.keys(selected).forEach(function (role) {
          var match = role.match(/^bundle_option_(\d+)$/);
          if (!match) return;
          optionValues[Number(match[1]) - 1] = selected[role];
        });

        if (!optionValues.length) return variants.find(function (variant) { return variant && variant.available; }) || variants[0] || null;

        var exactAvailable = variants.find(function (variant) {
          if (!variant || !variant.available || !Array.isArray(variant.options)) return false;
          return optionValues.every(function (value, index) { return !value || variant.options[index] === value; });
        });

        if (exactAvailable) return exactAvailable;

        return variants.find(function (variant) {
          if (!variant || !Array.isArray(variant.options)) return false;
          return optionValues.every(function (value, index) { return !value || variant.options[index] === value; });
        }) || variants[0] || null;
      }

      function setMessage(text, state) {
        if (!message) return;
        message.textContent = text || '';
        message.dataset.state = state || '';
      }

      function setBundleButtonState(button, disabled, soldOut) {
        if (!button) return;
        var label = button.querySelector('[data-rover-bundle-button-label]') || button.querySelector('span');
        if (label && !button.dataset.roverBundleDefaultLabel) {
          button.dataset.roverBundleDefaultLabel = label.textContent.trim();
        }
        if (label) {
          label.textContent = soldOut ? 'Sold out' : (button.dataset.roverBundleDefaultLabel || label.textContent);
        }
        button.disabled = Boolean(disabled);
        if (button.disabled) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
        button.classList.toggle('is-sold-out', Boolean(soldOut));
      }

      function getSelectedBundleVariantState(card) {
        var selectedControls = getSelectedVariantControls(card);
        var selectedValuesByRole = {};
        Object.keys(selectedControls).forEach(function (role) { selectedValuesByRole[role] = selectedControls[role].value; });
        return {
          selectedControls: selectedControls,
          selectedValuesByRole: selectedValuesByRole,
          selectedBundleVariant: getSelectedBundleVariant(card, selectedValuesByRole),
          hasBundleVariantMap: getBundleVariantMap(card).length > 0
        };
      }

      function updateCardPreviewImage(card, selectedControls, selectedBundleVariant) {
        if (!card) return;
        var media = card.querySelector('.rover-bundle-card__media');
        var image = media ? media.querySelector('img') : null;
        var selected = selectedControls || getSelectedVariantControls(card);
        var styleControl = Object.keys(selected).map(function (role) { return selected[role]; }).find(function (control) {
          return control && control.getAttribute('data-rover-bundle-preview-src');
        }) || null;

        if (!media) return;

        /* The Style close-up is injected on the Style radio and is the only image whose
           ZEISS mark stays readable in the 82px card box, so it wins here. The full
           bundle shot is still applied to the main gallery by updateMainGalleryImage. */
        var styleSrc = styleControl ? styleControl.getAttribute('data-rover-bundle-preview-src') || '' : '';
        var previewSrc = styleSrc || (selectedBundleVariant && selectedBundleVariant.previewSrc ? selectedBundleVariant.previewSrc : '');
        var previewSrcset = styleSrc
          ? (styleControl.getAttribute('data-rover-bundle-preview-srcset') || '')
          : (selectedBundleVariant && selectedBundleVariant.previewSrcset ? selectedBundleVariant.previewSrcset : '');
        var previewAlt = styleSrc
          ? (styleControl.getAttribute('data-rover-bundle-preview-alt') || styleControl.value || '')
          : (selectedBundleVariant && selectedBundleVariant.previewAlt ? selectedBundleVariant.previewAlt : '');

        if (!previewSrc) return;

        if (!image) {
          image = document.createElement('img');
          image.loading = 'eager';
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'high');
          media.textContent = '';
          media.appendChild(image);
        }

        if (previewSrcset) image.setAttribute('srcset', previewSrcset);
        else image.removeAttribute('srcset');
        image.setAttribute('sizes', '(max-width: 749px) 96px, 128px');
        image.alt = previewAlt;
        if (image.getAttribute('src') !== previewSrc) image.setAttribute('src', previewSrc);
      }

      function updateCardComposition(card) {
        if (!card) return [];
        var items = getCardItems(card);
        var composition = card.querySelector('[data-rover-bundle-composition]');
        var variantSelects = card.querySelectorAll('[data-rover-bundle-variant-select]');
        var priceNode = card.querySelector('[data-rover-bundle-price]');
        var savingsNode = card.querySelector('[data-rover-bundle-savings]');
        var cardAddButton = card.querySelector('[data-rover-bundle-card-add]');
        var selectedBundleVariantState = getSelectedBundleVariantState(card);
        var selectedControls = selectedBundleVariantState.selectedControls;
        var selectedValuesByRole = selectedBundleVariantState.selectedValuesByRole;
        var selectedBundleVariant = selectedBundleVariantState.selectedBundleVariant;
        var isSoldOut = selectedBundleVariantState.hasBundleVariantMap && selectedBundleVariant && selectedBundleVariant.available === false;
        updateCardPreviewImage(card, selectedControls, selectedBundleVariant);
        var bundleVariantSelect = selectedControls.bundle || null;
        if (bundleVariantSelect && selectedBundleVariant && selectedBundleVariant.id) {
          var selectedBundleVariantId = String(selectedBundleVariant.id);
          if (String(bundleVariantSelect.value) !== selectedBundleVariantId) bundleVariantSelect.value = selectedBundleVariantId;
        }
        if (selectedBundleVariant && selectedBundleVariant.id) {
          card.setAttribute('data-rover-bundle-selected-variant-id', String(selectedBundleVariant.id));
          card.setAttribute('data-rover-bundle-selected-sku', selectedBundleVariant.sku ? String(selectedBundleVariant.sku) : '');
        } else {
          card.removeAttribute('data-rover-bundle-selected-variant-id');
          card.removeAttribute('data-rover-bundle-selected-sku');
        }
        card.setAttribute('data-rover-bundle-item-count', String(items.length));
        card.setAttribute('data-rover-bundle-sold-out', isSoldOut ? 'true' : 'false');
        card.classList.toggle('is-sold-out', Boolean(isSoldOut));
        setBundleButtonState(cardAddButton, isMarketRestricted || !items.length || isSoldOut, Boolean(isSoldOut) && !isMarketRestricted);

        var priceSourceSelect = bundleVariantSelect || selectedControls.included_1 || Object.keys(selectedControls).map(function (role) { return selectedControls[role]; })[0];
        if (priceNode && selectedBundleVariant && selectedBundleVariant.priceNote) {
          priceNode.textContent = selectedBundleVariant.priceNote;
        } else if (priceNode && priceSourceSelect) {
          var selectedOption = priceSourceSelect.options && priceSourceSelect.selectedIndex >= 0 ? priceSourceSelect.options[priceSourceSelect.selectedIndex] : null;
          var priceNote = selectedOption ? selectedOption.getAttribute('data-price-note') : priceSourceSelect.getAttribute('data-price-note');
          if (priceNote) priceNode.textContent = priceNote;
        }

        if (savingsNode) {
          var savingsTemplate = card.getAttribute('data-rover-bundle-savings-template') || 'Save {amount} vs buying separately';
          var savingsText = selectedBundleVariant && selectedBundleVariant.savingsNote
            ? savingsTemplate.replace('{amount}', selectedBundleVariant.savingsNote)
            : '';
          savingsNode.textContent = savingsText;
          savingsNode.hidden = !savingsText;
        }

        if (composition) {
          if (!items.length) {
            composition.textContent = 'Assign products in Shopify admin';
          } else if (bundleVariantSelect || selectedBundleVariant) {
            composition.textContent = selectedBundleVariant && selectedBundleVariant.composition
              ? selectedBundleVariant.composition
              : 'Includes Power Plus + Bluetooth Controller';
          } else if (variantSelects.length && items.length === 1) {
            composition.textContent = 'Adds 1 bundle SKU · selectable variant';
          } else if (variantSelects.length) {
            composition.textContent = 'Includes ' + items.length + (items.length === 1 ? ' item' : ' items') + ' · editable options';
          } else {
            composition.textContent = 'Includes ' + items.length + (items.length === 1 ? ' item' : ' items');
          }
        }

        return items;
      }

      function markCardSoldOut(card) {
        var state = getSelectedBundleVariantState(card);
        if (!state.selectedBundleVariant || !state.selectedBundleVariant.id) return false;
        if (!card._roverBundleSoldOutVariantIds) card._roverBundleSoldOutVariantIds = {};
        card._roverBundleSoldOutVariantIds[String(state.selectedBundleVariant.id)] = true;
        updateCardComposition(card);
        if (selectedCard === card && addButton) {
          var selectedItems = getCardItems(card);
          setBundleButtonState(addButton, true, selectedItems.length > 0 && !isMarketRestricted);
        }
        return true;
      }

      function addItemsForCard(card, button) {
        if (isMarketRestricted) {
          setMessage(marketRestrictedMessage, 'error');
          return;
        }

        var selectedBundleVariantState = getSelectedBundleVariantState(card);
        var selectedBundleVariant = selectedBundleVariantState.selectedBundleVariant;
        var isSoldOut = selectedBundleVariantState.hasBundleVariantMap && selectedBundleVariant && selectedBundleVariant.available === false;
        var items = getCardItems(card);
        if (isSoldOut) {
          markCardSoldOut(card);
          setMessage('Sold out', 'error');
          return;
        }
        if (!items.length || (button && button.disabled)) {
          setMessage('Select a package after Rover SKUs are assigned.', 'error');
          return;
        }

        if (button) button.disabled = true;
        if (addButton) addButton.disabled = true;
        cardAddButtons.forEach(function (candidateButton) { candidateButton.disabled = true; });
        root.classList.add('is-adding');
        setMessage('Adding package...', 'pending');

        var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
        var addPayload = { items: items };
        if (document.getElementById('cart-drawer') || document.querySelector('cart-drawer')) {
          addPayload.sections = ['cart-drawer'];
          addPayload.sections_url = window.location.pathname;
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(addPayload)
        }).then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () { return {}; }).then(function (payload) {
              var error = new Error('Bundle add failed');
              error.status = response.status;
              error.payload = payload;
              throw error;
            });
          }
          return response.json();
        }).then(function (payload) {
          setMessage('Package added to cart.', 'success');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.roverOpenCartDrawer) {
            window.roverOpenCartDrawer({ sections: payload && payload.sections });
          }
        }).catch(function (error) {
          var errorText = error && error.payload ? JSON.stringify(error.payload).toLowerCase() : '';
          var inventoryError = Boolean(error && (error.status === 409 || error.status === 422)) || /inventory|stock|sold out|not enough|unavailable/.test(errorText);
          if (inventoryError && markCardSoldOut(card)) {
            setMessage('Sold out', 'error');
          } else {
            setMessage('This package is not available yet.', 'error');
          }
        }).finally(function () {
          root.classList.remove('is-adding');
          cards.forEach(updateCardComposition);
          var selectedItems = selectedCard ? updateCardComposition(selectedCard) : [];
          var selectedCardSoldOut = selectedCard && selectedCard.getAttribute('data-rover-bundle-sold-out') === 'true';
          if (addButton) setBundleButtonState(addButton, isMarketRestricted || !selectedItems.length || selectedCardSoldOut, Boolean(selectedCardSoldOut) && !isMarketRestricted);
        });
      }

      /* Rover bundle preview -> main product gallery.
         The gallery lazy-loads non-preload slides through yg-image, where the real
         URL lives in data-src and src is a 1px GIF. Writing only src is a no-op there,
         so both attributes are written. The original values are stashed once so a later
         selection (or no selection) can restore the real product photo instead of
         leaving a bundle photo permanently burned into the slide. */
      function getActiveGalleryMedia(gallery) {
        var mediaCarousel = gallery.querySelector('media-carousel');
        if (!mediaCarousel) return null;

        var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__media'));
        var visible = mediaItems.filter(function (item) { return !item.hidden; });
        if (!visible.length) return null;

        // aria-current on the thumbnail list is kept in sync by the gallery filter.
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumbnail'));
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('aria-current') === 'true') {
            var byIndex = visible[i];
            if (byIndex) return byIndex;
          }
        }

        // Otherwise fall back to whichever visible slide the carousel is scrolled to.
        var scrollLeft = mediaCarousel.scrollLeft || 0;
        var best = visible[0];
        var bestDistance = Infinity;
        visible.forEach(function (item) {
          var distance = Math.abs(item.offsetLeft - scrollLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = item;
          }
        });
        return best;
      }

      function setGallerySlideImage(media, src, srcset, alt) {
        if (!media || !src) return;
        // Desktop and mobile <img> pairs both exist inside a yg-image wrapper.
        Array.prototype.slice.call(media.querySelectorAll('img')).forEach(function (img) {
          if (!img.dataset.roverBundleOriginalSrc) {
            img.dataset.roverBundleOriginalSrc = img.getAttribute('src') || '';
            img.dataset.roverBundleOriginalSrcset = img.getAttribute('srcset') || '';
            img.dataset.roverBundleOriginalDataSrc = img.getAttribute('data-src') || '';
            img.dataset.roverBundleOriginalAlt = img.getAttribute('alt') || '';
          }

          img.setAttribute('src', src);
          img.setAttribute('data-src', src);
          if (srcset) {
            img.setAttribute('srcset', srcset);
          } else {
            img.removeAttribute('srcset');
          }
          // Stop the lazy loader from restoring the placeholder over our src.
          img.setAttribute('data-rover-bundle-locked', 'true');
          img.setAttribute('alt', alt || '');
        });
      }

      function restoreGallerySlideImage(media) {
        if (!media) return;
        Array.prototype.slice.call(media.querySelectorAll('img')).forEach(function (img) {
          if (!img.dataset.roverBundleOriginalSrc) return;
          var originalSrc = img.dataset.roverBundleOriginalSrc;
          var originalDataSrc = img.dataset.roverBundleOriginalDataSrc;

          if (originalDataSrc) {
            img.setAttribute('src', originalSrc);
            img.setAttribute('data-src', originalDataSrc);
          } else {
            img.removeAttribute('data-src');
            img.setAttribute('src', originalSrc);
          }

          if (img.dataset.roverBundleOriginalSrcset) {
            img.setAttribute('srcset', img.dataset.roverBundleOriginalSrcset);
          } else {
            img.removeAttribute('srcset');
          }
          img.setAttribute('alt', img.dataset.roverBundleOriginalAlt || '');

          delete img.dataset.roverBundleOriginalSrc;
          delete img.dataset.roverBundleOriginalSrcset;
          delete img.dataset.roverBundleOriginalDataSrc;
          delete img.dataset.roverBundleOriginalAlt;
          delete img.dataset.roverBundleLocked;
        });
      }

      function updateMainGalleryImage(card) {
        var gallery = document.querySelector('.product-gallery');
        if (!gallery) return;

        var state = card ? getSelectedBundleVariantState(card) : null;
        var variant = state && state.selectedBundleVariant;
        var media = getActiveGalleryMedia(gallery);
        if (!media) return;

        if (variant && variant.previewSrc) {
          setGallerySlideImage(media, variant.previewSrc, variant.previewSrcset, variant.previewAlt || variant.title || '');
        } else {
          restoreGallerySlideImage(media);
        }
      }

      function select(card) {
        selectedCard = card || null;
        cards.forEach(function (candidate) {
          var active = candidate === selectedCard;
          candidate.classList.toggle('is-selected', active);
          candidate.setAttribute('aria-checked', active ? 'true' : 'false');
          updateCardComposition(candidate);
        });

        var selectedItems = updateCardComposition(selectedCard);
        updateMainGalleryImage(selectedCard);
        var selectedCardSoldOut = selectedCard && selectedCard.getAttribute('data-rover-bundle-sold-out') === 'true';
        if (addButton) setBundleButtonState(addButton, isMarketRestricted || !selectedItems.length || selectedCardSoldOut, Boolean(selectedCardSoldOut) && !isMarketRestricted);
        if (isMarketRestricted) {
          setMessage(marketRestrictedMessage, 'error');
        } else if (!selectedItems.length) {
          setMessage('This package is ready to configure in Shopify admin. Assign SKU products before testing checkout.', 'pending');
        } else {
          setMessage('', '');
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.target && event.target.closest && event.target.closest('select, option, label, input, textarea')) return;
          select(card);
        });

        card.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          select(card);
        });

        card.querySelectorAll('[data-rover-bundle-variant-select]').forEach(function (variantSelect) {
          variantSelect.addEventListener('change', function () {
            select(card);
          });
        });

        card.querySelectorAll('[data-rover-bundle-card-add]').forEach(function (cardAddButton) {
          cardAddButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            select(card);
            addItemsForCard(card, cardAddButton);
          });
        });
      });

      if (addButton) {
        addButton.addEventListener('click', function () {
          addItemsForCard(selectedCard, addButton);
        });
      }

      select(selectedCard);
    });
  }

  function initVideoStageScroll(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-vct]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-vct]')));

    roots.forEach(function (root) {
      if (root.dataset.roverVctBound === 'true') return;
      root.dataset.roverVctBound = 'true';

      var video = root.querySelector('video');
      prepareVideo(video, 'auto');

      var compactVct = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

      if (compactVct) {
        root.style.setProperty('--rover-vct-progress', '1');
        root.style.setProperty('--rover-vct-scale', '1');
        root.style.setProperty('--rover-vct-y', '0vh');
        root.style.setProperty('--rover-vct-caption-opacity', '1');
        root.classList.add('is-vct-expanded');

        if (video && !prefersReducedMotion()) {
          if ('IntersectionObserver' in window) {
            var compactObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  root.classList.add('is-vct-playing');
                  playPreparedVideo(video);
                } else {
                  root.classList.remove('is-vct-playing');
                  pauseVideo(video);
                }
              });
            }, { threshold: 0.35 });
            compactObserver.observe(root);
          } else {
            root.classList.add('is-vct-playing');
            playPreparedVideo(video);
          }
        }
        return;
      }

      if (!root.classList.contains('rover-video-stage--scroll') || prefersReducedMotion()) {
        root.style.setProperty('--rover-vct-progress', '1');
        root.style.setProperty('--rover-vct-scale', '1');
        if (video && !prefersReducedMotion()) playPreparedVideo(video);
        return;
      }

      var frameRequested = false;

      function update() {
        frameRequested = false;
        var rect = root.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        var travel = Math.max(1, rect.height - viewportHeight);
        var progress = clamp((0 - rect.top) / travel, 0, 1);
        var eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        var scale = 0.61 + eased * 0.39;
        var y = (1 - eased) * 8;
        var captionOpacity = clamp(1 - progress * 1.8, 0, 1);

        root.style.setProperty('--rover-vct-progress', progress.toFixed(4));
        root.style.setProperty('--rover-vct-scale', scale.toFixed(4));
        root.style.setProperty('--rover-vct-y', y.toFixed(3) + 'vh');
        root.style.setProperty('--rover-vct-caption-opacity', captionOpacity.toFixed(4));
        root.classList.toggle('is-vct-expanded', progress > 0.86);
        root.classList.toggle('is-vct-playing', progress > 0.72 && rect.bottom > viewportHeight * 0.2 && rect.top < viewportHeight * 0.8);

        if (video) {
          if (root.classList.contains('is-vct-playing')) {
            playPreparedVideo(video);
          } else if (progress < 0.18 || rect.bottom <= 0 || rect.top >= viewportHeight) {
            pauseVideo(video);
          }
        }
      }

      function requestUpdate() {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    });
  }

  function initStaticPerspective(root, video) {
    if (!root) return;
    root.dataset.roverPerspectiveMode = 'static-expanded';

    var frameRequested = false;

    function setPx(name, value) {
      root.style.setProperty(name, value.toFixed(3) + 'px');
    }

    function isCompactViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function updateStaticLayout() {
      frameRequested = false;
      var compact = isCompactViewport();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var viewportWidth = getLayoutViewportWidth();
      var canvas = root.querySelector('.rover-figma-canvas');
      var canvasRect = canvas ? canvas.getBoundingClientRect() : root.getBoundingClientRect();
      var canvasWidth = canvasRect && canvasRect.width ? canvasRect.width : viewportWidth;
      var viewportCenterWithinCanvas = getViewportCenterWithin(canvasRect, viewportWidth);
      var mediaWidthLimit = compact ? 430 : 1440;
      var mediaInsetX = compact ? 24 : 72;
      var mediaInsetY = compact ? 96 : 56;
      var maxByViewportWidth = Math.max(1, viewportWidth - mediaInsetX);
      var maxByCanvasWidth = Math.max(1, canvasWidth - mediaInsetX);
      var maxByViewportHeight = Math.max(1, viewportHeight - mediaInsetY) * 16 / 9;
      var videoWidth = Math.min(mediaWidthLimit, maxByViewportWidth, maxByCanvasWidth, maxByViewportHeight);

      var videoHeight = videoWidth * 9 / 16;
      var verticalPad = compact ? clamp(viewportHeight * 0.07, 42, 72) : clamp(viewportHeight * 0.12, 96, 160);
      var sectionHeight = Math.ceil(videoHeight + verticalPad);
      var windowLeft = viewportCenterWithinCanvas - (videoWidth / 2);
      var windowTop = (sectionHeight - videoHeight) / 2;

      root.classList.add('is-vct-static-expanded');
      root.classList.add('is-vct-expanded');
      root.classList.toggle('is-mobile-vct-expanded', compact);
      root.classList.remove('is-mobile-vct-parked');
      root.style.setProperty('--rover-statement-progress', '1');
      root.style.setProperty('--rover-statement-copy-opacity', '0');
      root.style.setProperty('--rover-statement-sticky-top', '0px');
      root.style.setProperty('--rover-statement-static-transform', 'none');
      root.style.setProperty('--rover-statement-static-section-height', sectionHeight.toFixed(3) + 'px');
      root.style.setProperty('--rover-statement-mobile-track-height', sectionHeight.toFixed(3) + 'px');
      setPx('--rover-statement-sticky-height', sectionHeight);
      setPx('--rover-statement-window-left', windowLeft);
      setPx('--rover-statement-window-top', windowTop);
      setPx('--rover-statement-window-width', videoWidth);
      setPx('--rover-statement-window-height', videoHeight);
      root.style.setProperty('--rover-statement-window-radius', '0px');
      setPx('--rover-statement-copy-center', windowTop + (videoHeight / 2));
    }

    function requestStaticLayout() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateStaticLayout);
    }

    function setStaticPlaying(playing) {
      root.classList.toggle('is-vct-playing', playing);
      if (!video) return;
      if (playing) playPreparedVideo(video);
      else pauseVideo(video);
    }

    updateStaticLayout();
    window.addEventListener('resize', requestStaticLayout, { passive: true });

    root.addEventListener('rover:perspective:watch', function () {
      updateStaticLayout();
      var top = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      window.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      setStaticPlaying(!prefersReducedMotion());
    });

    if (video && !prefersReducedMotion()) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            setStaticPlaying(entry.isIntersecting && entry.intersectionRatio > 0.12);
          });
        }, { rootMargin: '180px 0px 180px 0px', threshold: [0, 0.12, 0.4] });
        observer.observe(root);
      } else {
        setStaticPlaying(true);
      }
    }
  }

  function initPerspectiveScroll(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-rover-perspective]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rover-perspective]')));

    roots.forEach(function (root) {
      if (root.dataset.roverPerspectiveBound === 'true') return;
      root.dataset.roverPerspectiveBound = 'true';

      var video = root.querySelector('video');
      prepareVideo(video, 'auto');
      prewarmVideo(video);

      if (forceStaticPerspective) {
        initStaticPerspective(root, video);
        return;
      }

      var copyParts = Array.prototype.slice.call(root.querySelectorAll('.rover-statement__title > span:not(.rover-statement__window)'));
      var firstCopy = copyParts[0];
      var lastCopy = copyParts[copyParts.length - 1];
      var frameRequested = false;
      var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var lastScrollDirection = 1;
      var mobilePhase = 'before';
      var mobileParkUntil = 0;
      var mobileParkScrollTop = 0;
      var mobileHasExpanded = false;
      var mobileParkedAt = 0;
      var touchStartPhase = 'before';
      var lastScrollDelta = 0;
      var mobileWheelCanExpand = false;
      var mobileWheelQuietTimer = null;
      var mobileParkLockUntil = 0;

      function interpolate(start, end, progress) {
        return start + ((end - start) * progress);
      }

      function smoothstep(value) {
        value = clamp(value, 0, 1);
        return value * value * (3 - (2 * value));
      }

      function setValue(name, value) {
        root.style.setProperty(name, value.toFixed(3) + 'px');
      }

      function armMobileWheelExpansion(delay) {
        if (mobileWheelQuietTimer) window.clearTimeout(mobileWheelQuietTimer);
        mobileWheelQuietTimer = window.setTimeout(function () {
          if (mobilePhase === 'parked' && !mobileHasExpanded && Date.now() >= mobileParkUntil) mobileWheelCanExpand = true;
        }, delay || 440);
      }

      function getScrollY() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }

      function isCompactViewport() {
        return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      }

      function getStickyHeaderOffset() {
        var candidates = Array.prototype.slice.call(document.querySelectorAll('header, [data-sticky-header], .shopify-section-group-header-group'));
        var offset = 0;

        candidates.forEach(function (element) {
          var styles = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          if ((styles.position === 'fixed' || styles.position === 'sticky') && rect.top <= 1 && rect.bottom > 0) {
            offset = Math.max(offset, rect.bottom);
          }
        });

        return Math.min(offset, (window.innerHeight || 1) * 0.24);
      }

      function getPerspectiveMetrics() {
        var compact = isCompactViewport();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        var viewportWidth = getLayoutViewportWidth();
        var canvas = root.querySelector('.rover-figma-canvas');
        var canvasRect = canvas ? canvas.getBoundingClientRect() : root.getBoundingClientRect();
        var canvasWidth = canvasRect && canvasRect.width ? canvasRect.width : viewportWidth;
        var viewportCenterWithinCanvas = getViewportCenterWithin(canvasRect, viewportWidth);
        var stickyHeaderOffset = getStickyHeaderOffset();
        var availableHeight = Math.max(1, viewportHeight - stickyHeaderOffset);
        var rect = root.getBoundingClientRect();
        var designScale = compact ? clamp(canvasWidth / 375, 0.82, 1.18) : clamp(canvasWidth / 1920, 0.39, 1);
        var compactHeight = compact ? clamp(210.9375 * designScale, 184, Math.min(availableHeight * 0.46, 230)) : availableHeight;
        var compactTop = stickyHeaderOffset + Math.max(0, (availableHeight - compactHeight) / 2);
        var compactCollapsedTrack = compactHeight;
        var compactExpandedTrack = Math.max(availableHeight * 1.28, 620);
        var travelHeight = compact ? compactExpandedTrack : root.offsetHeight;
        var travel = Math.max(1, travelHeight - availableHeight);
        var rawProgress = clamp((0 - rect.top) / travel, 0, 1);

        return {
          compact: compact,
          viewportHeight: viewportHeight,
          viewportWidth: viewportWidth,
          canvasWidth: canvasWidth,
          canvasRect: canvasRect,
          viewportCenterWithinCanvas: viewportCenterWithinCanvas,
          stickyHeaderOffset: stickyHeaderOffset,
          availableHeight: availableHeight,
          compactHeight: compactHeight,
          compactTop: compactTop,
          compactCollapsedTrack: compactCollapsedTrack,
          compactExpandedTrack: compactExpandedTrack,
          rect: rect,
          travel: travel,
          rawProgress: rawProgress
        };
      }

      function parkMobilePerspective(metrics) {
        if (mobilePhase !== 'before' || mobileHasExpanded) return;
        var sectionTop = metrics.rect.top + getScrollY();
        mobilePhase = 'parked';
        mobileParkUntil = Date.now() + 380;
        mobileParkedAt = Date.now();
        mobileParkLockUntil = Date.now() + 760;
        mobileWheelCanExpand = false;
        mobileParkScrollTop = Math.max(0, sectionTop - metrics.compactTop);
        root.classList.add('is-mobile-vct-parked');
        root.classList.remove('is-mobile-vct-expanded');
        root.style.setProperty('--rover-statement-mobile-track-height', metrics.compactCollapsedTrack.toFixed(3) + 'px');
        window.scrollTo({ top: mobileParkScrollTop, behavior: 'auto' });
        armMobileWheelExpansion(440);
      }

      function releaseMobilePerspective() {
        if (mobileHasExpanded) return;
        mobilePhase = 'before';
        mobileWheelCanExpand = false;
        mobileParkLockUntil = 0;
        root.classList.remove('is-mobile-vct-parked');
        var metrics = getPerspectiveMetrics();
        root.style.setProperty('--rover-statement-mobile-track-height', metrics.compactCollapsedTrack.toFixed(3) + 'px');
      }

      function expandMobilePerspective(metrics) {
        mobilePhase = 'expanded';
        mobileHasExpanded = true;
        mobileWheelCanExpand = false;
        mobileParkLockUntil = 0;
        root.classList.remove('is-mobile-vct-parked');
        root.classList.add('is-mobile-vct-expanded');
        root.classList.add('is-vct-playing');
        root.style.setProperty('--rover-statement-mobile-track-height', metrics.compactExpandedTrack.toFixed(3) + 'px');
        if (video) playPreparedVideo(video);
      }

      function updateMobilePhase(metrics) {
        if (!metrics.compact || prefersReducedMotion()) {
          mobilePhase = 'before';
          return;
        }

        if (mobileHasExpanded) {
          mobilePhase = 'expanded';
          root.classList.remove('is-mobile-vct-parked');
          root.classList.add('is-mobile-vct-expanded');
          return;
        }

        var currentScroll = getScrollY();
        var sectionTop = metrics.rect.top + currentScroll;
        var parkScrollTop = Math.max(0, sectionTop - metrics.compactTop);
        var previousScroll = currentScroll - lastScrollDelta;
        var parkLead = Math.max(56, Math.min(92, metrics.compactHeight * 0.42));
        var crossedByFastScroll = lastScrollDirection > 0 && previousScroll < parkScrollTop - parkLead && currentScroll >= parkScrollTop - parkLead;
        var crossedParkPoint = currentScroll >= parkScrollTop - parkLead && currentScroll <= sectionTop + Math.max(metrics.viewportHeight * 2.35, metrics.compactCollapsedTrack + 760);

        if (mobilePhase === 'before' && lastScrollDirection > 0 && (crossedByFastScroll || crossedParkPoint) && metrics.rect.top < metrics.viewportHeight * 1.5) {
          parkMobilePerspective(metrics);
          return;
        }

        if (mobilePhase === 'parked' && !mobileHasExpanded && mobileParkScrollTop) {
          if (metrics.rect.bottom <= 0 || metrics.rect.top > metrics.viewportHeight * 1.1) {
            mobilePhase = 'before';
            mobileParkLockUntil = 0;
            root.classList.remove('is-mobile-vct-parked');
            return;
          }

          if (Math.abs(currentScroll - mobileParkScrollTop) > 2) {
            window.scrollTo({ top: mobileParkScrollTop, behavior: 'auto' });
          }
          return;
        }

        if (metrics.rect.bottom <= 0 || metrics.rect.top > metrics.viewportHeight * 1.1) {
          mobilePhase = 'before';
          mobileParkLockUntil = 0;
          root.classList.remove('is-mobile-vct-parked');
          return;
        }
      }

      function update() {
        frameRequested = false;
        var metrics = getPerspectiveMetrics();
        var compact = metrics.compact;
        var reduced = prefersReducedMotion();
        var viewportHeight = metrics.viewportHeight;
        var canvasWidth = metrics.canvasWidth;
        var stickyHeaderOffset = metrics.stickyHeaderOffset;
        var availableHeight = metrics.availableHeight;
        var rect = metrics.rect;
        updateMobilePhase(metrics);
        var designScale = compact ? clamp(canvasWidth / 375, 0.82, 1.18) : clamp(canvasWidth / 1920, 0.39, 1);
        var designOffset = compact ? 0 : (canvasWidth - (1920 * designScale)) / 2;
        var progress;
        var visualHeight = availableHeight;

        if (compact) {
          var mobileExpandedHeight = Math.min(canvasWidth * 9 / 16, Math.max(metrics.compactHeight, availableHeight - 112));
          progress = mobilePhase === 'expanded' ? 1 : 0;
          visualHeight = interpolate(metrics.compactHeight, mobileExpandedHeight, smoothstep(progress));
          root.style.setProperty('--rover-statement-mobile-track-height', (mobilePhase === 'expanded' ? metrics.compactExpandedTrack : metrics.compactCollapsedTrack).toFixed(3) + 'px');
        } else {
          var rawProgress = metrics.rawProgress;
          var completionPoint = 0.58;
          progress = reduced ? 0 : clamp(rawProgress / completionPoint, 0, 1);
        }

        var inlineLimit = compact ? 0.16 : 0.24;
        var inlineProgress = clamp(progress / inlineLimit, 0, 1);
        var fullscreenProgress = clamp((progress - inlineLimit) / (1 - inlineLimit), 0, 1);
        var easedFullscreen = smoothstep(fullscreenProgress);
        var fadeStart = compact ? 0.58 : 0.8;
        var copyOpacity = fullscreenProgress < fadeStart ? 1 : 1 - ((fullscreenProgress - fadeStart) / (1 - fadeStart));
        if (compact) copyOpacity = 0;
        if (progress >= 0.985) copyOpacity = 0;

        var startWidth = compact ? clamp(canvasWidth * 0.48, 154, 210) : 56.5 * designScale;
        var startHeight = compact ? startWidth * 9 / 16 : 31.5 * designScale;
        var startLeft = compact ? (canvasWidth - startWidth) / 2 : 778 * designScale + designOffset;
        var startTop = compact ? (visualHeight - startHeight) / 2 : (visualHeight - (63 * designScale)) / 2;
        var inlineLeft = compact ? startLeft : interpolate(778, 686.75, inlineProgress) * designScale + designOffset;
        var inlineTop = compact ? startTop : (availableHeight - (63 * designScale)) / 2;
        var inlineWidth = compact ? startWidth : interpolate(113, 169.5, inlineProgress) * designScale;
        var inlineHeight = compact ? startHeight : interpolate(63, 94.5, inlineProgress) * designScale;
        var safeX = compact ? clamp(canvasWidth * 0.04, 12, 20) : clamp(canvasWidth * 0.025, 28, 48);
        var safeY = compact ? clamp(availableHeight * 0.07, 22, 48) : clamp(availableHeight * 0.08, 56, 92);
        var maxVideoWidth = Math.min(Math.max(1, canvasWidth - (safeX * 2)), Math.max(1, availableHeight - (safeY * 2)) * 16 / 9);
        if (!compact) maxVideoWidth = Math.min(maxVideoWidth, 1440);
        var maxVideoHeight = maxVideoWidth * 9 / 16;
        var fullLeft = (metrics.viewportCenterWithinCanvas || canvasWidth / 2) - (maxVideoWidth / 2);
        var fullTop = compact ? 0 : (availableHeight - maxVideoHeight) / 2;
        var windowLeft = interpolate(inlineLeft, fullLeft, easedFullscreen);
        var windowTop = interpolate(inlineTop, fullTop, easedFullscreen);
        var windowWidth = interpolate(inlineWidth, maxVideoWidth, easedFullscreen);
        var windowHeight = interpolate(inlineHeight, maxVideoHeight, easedFullscreen);
        var fontSize = compact ? clamp(interpolate(32, 38, inlineProgress) * designScale, 28, 40) : clamp(interpolate(64, 96, inlineProgress) * designScale, 26, 96);
        var gap = compact ? clamp(interpolate(16, 30, easedFullscreen) * designScale, 14, 34) : clamp(interpolate(10, 22, inlineProgress) * designScale, 10, 24);

        root.style.setProperty('--rover-statement-progress', progress.toFixed(4));
        root.style.setProperty('--rover-statement-copy-opacity', copyOpacity.toFixed(4));
        setValue('--rover-statement-font-size', fontSize);
        setValue('--rover-statement-gap', gap);
        setValue('--rover-statement-window-left', windowLeft);
        setValue('--rover-statement-window-top', windowTop);
        setValue('--rover-statement-window-width', windowWidth);
        setValue('--rover-statement-window-height', windowHeight);
        setValue('--rover-statement-window-radius', interpolate(4.373 * designScale, 0, easedFullscreen));
        setValue('--rover-statement-copy-center', windowTop + (windowHeight / 2));

        if (compact) {
          setValue('--rover-statement-mobile-first-center', windowTop - gap - (fontSize * 0.46));
          setValue('--rover-statement-mobile-last-center', windowTop + windowHeight + gap + (fontSize * 0.46));
          setValue('--rover-statement-sticky-top', stickyHeaderOffset + Math.max(0, (availableHeight - visualHeight) / 2));
          setValue('--rover-statement-sticky-height', visualHeight);
        } else {
          var firstWidth = firstCopy ? firstCopy.getBoundingClientRect().width : 0;
          var lastWidth = lastCopy ? lastCopy.getBoundingClientRect().width : 0;
          var minCopyInset = Math.max(24, canvasWidth * 0.025);
          var firstLeft = windowLeft - gap - firstWidth;
          var lastLeft = windowLeft + windowWidth + gap;
          var copyOverflow = Math.max(minCopyInset - firstLeft, (lastLeft + lastWidth) - (canvasWidth - minCopyInset), 0);
          var edgeFadeDistance = clamp(canvasWidth * 0.055, 72, 120);
          copyOpacity = Math.min(copyOpacity, clamp(1 - (copyOverflow / edgeFadeDistance), 0, 1));
          root.style.setProperty('--rover-statement-copy-opacity', copyOpacity.toFixed(4));
          setValue('--rover-statement-first-left', firstLeft);
          setValue('--rover-statement-last-left', lastLeft);
        }

        if (!compact) {
          setValue('--rover-statement-sticky-top', stickyHeaderOffset);
          setValue('--rover-statement-sticky-height', visualHeight);
        }

        root.classList.toggle('is-vct-expanded', compact ? progress > 0.96 : progress > 0.86);
        root.classList.toggle('is-vct-playing', rect.bottom > 0 && rect.top < viewportHeight && !reduced && (compact ? progress > 0.02 : progress > 0.12));

        if (video) {
          if (root.classList.contains('is-vct-playing')) {
            playPreparedVideo(video);
          } else if (progress < 0.05 || rect.bottom <= 0 || rect.top >= viewportHeight) {
            pauseVideo(video);
          }
        }
      }

      function requestUpdate() {
        var scrollY = getScrollY();
        lastScrollDelta = scrollY - lastScrollY;
        lastScrollDirection = scrollY >= lastScrollY ? 1 : -1;
        lastScrollY = scrollY;
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(update);
      }

      var touchStartY = null;

      function handleMobileWheel(event) {
        if (!isCompactViewport() || prefersReducedMotion() || mobileHasExpanded) return;
        var metrics = getPerspectiveMetrics();

        if (mobilePhase === 'parked') {
          if (event.deltaY < -12) {
            if (event.cancelable) event.preventDefault();
            releaseMobilePerspective();
            requestUpdate();
            return;
          }

          if (event.deltaY <= 12) return;

          if (event.cancelable) event.preventDefault();
          if (mobileParkScrollTop) window.scrollTo({ top: mobileParkScrollTop, behavior: 'auto' });

          if (Date.now() < mobileParkUntil || Date.now() - mobileParkedAt < 180) {
            armMobileWheelExpansion(240);
            return;
          }

          if (!mobileWheelCanExpand) {
            armMobileWheelExpansion(220);
            return;
          }

          expandMobilePerspective(metrics);
          requestUpdate();
          return;
        }

        if (event.deltaY <= 12) return;

        if (mobilePhase === 'before' && metrics.rect.top <= metrics.compactTop + 92 && metrics.rect.bottom > metrics.viewportHeight * 0.24) {
          if (event.cancelable) event.preventDefault();
          parkMobilePerspective(metrics);
          requestUpdate();
          return;
        }
      }

      function handleTouchStart(event) {
        if (!isCompactViewport() || !event.touches || !event.touches.length) return;
        touchStartY = event.touches[0].clientY;
        touchStartPhase = mobilePhase;
      }

      function handleTouchMove(event) {
        if (!isCompactViewport() || touchStartY === null || mobileHasExpanded) return;
        if (!event.touches || !event.touches.length) return;
        var deltaY = event.touches[0].clientY - touchStartY;

        if (mobilePhase === 'before' && deltaY < -10) {
          var beforeMetrics = getPerspectiveMetrics();
          if (beforeMetrics.rect.top <= beforeMetrics.compactTop + 92 && beforeMetrics.rect.bottom > beforeMetrics.viewportHeight * 0.24) {
            if (event.cancelable) event.preventDefault();
            parkMobilePerspective(beforeMetrics);
            requestUpdate();
            return;
          }
        }

        if (mobilePhase !== 'parked') return;

        if (touchStartPhase === 'parked' && deltaY > 16) {
          releaseMobilePerspective();
          requestUpdate();
          return;
        }

        if (event.cancelable) event.preventDefault();
        if (mobileParkScrollTop) window.scrollTo({ top: mobileParkScrollTop, behavior: 'auto' });
        if (touchStartPhase !== 'parked') return;

        if (deltaY < -24 && Date.now() >= mobileParkUntil && Date.now() - mobileParkedAt >= 160) {
          expandMobilePerspective(getPerspectiveMetrics());
          requestUpdate();
        }
      }

      function handleTouchEnd(event) {
        if (!isCompactViewport() || touchStartY === null || !event.changedTouches || !event.changedTouches.length) return;
        touchStartY = null;
        touchStartPhase = mobilePhase;
        requestUpdate();
      }

      root.addEventListener('rover:perspective:watch', function () {
        var metrics = getPerspectiveMetrics();
        if (metrics.compact) {
          var sectionTop = metrics.rect.top + getScrollY();
          mobilePhase = 'parked';
          mobileWheelCanExpand = false;
          mobileParkScrollTop = Math.max(0, sectionTop - metrics.compactTop);
          root.classList.add('is-mobile-vct-parked');
          root.style.setProperty('--rover-statement-mobile-track-height', metrics.compactCollapsedTrack.toFixed(3) + 'px');
          window.scrollTo({ top: mobileParkScrollTop, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
          window.setTimeout(function () {
            expandMobilePerspective(getPerspectiveMetrics());
            requestUpdate();
          }, prefersReducedMotion() ? 0 : 280);
        } else {
          var sectionTop = metrics.rect.top + getScrollY();
          var target = sectionTop + Math.max(0, (root.offsetHeight - metrics.availableHeight) * 0.64);
          window.scrollTo({ top: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        }
        requestUpdate();
      });

      update();
      window.addEventListener('wheel', handleMobileWheel, { passive: false });
      window.addEventListener('touchstart', handleTouchStart, { passive: true });
      window.addEventListener('touchmove', handleTouchMove, { passive: false });
      window.addEventListener('touchend', handleTouchEnd, { passive: false });
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    });
  }

  function initRoverContinuousAiGradientSpan(scope) {
    var doc = document;
    var root = doc.documentElement;
    var scheduled = 0;
    var observer = window.__roverAiGradientSpanObserver || null;

    function getGradientSections() {
      var first = doc.querySelector('.section-rover-specs');
      var last = doc.querySelector('.section-rover-ai-split');
      if (!first || !last) return null;
      var sections = Array.prototype.slice.call(doc.querySelectorAll('.section-rover-specs, .section-rover-ai-tabs, .section-rover-ai-split'));
      return { first: first, last: last, sections: sections };
    }

    function updateGradientSpan() {
      scheduled = 0;
      var targets = getGradientSections();
      if (!targets) return;

      var firstRect = targets.first.getBoundingClientRect();
      var lastRect = targets.last.getBoundingClientRect();
      var span = Math.ceil(Math.max(targets.first.offsetHeight || 0, lastRect.bottom - firstRect.top));
      if (!Number.isFinite(span) || span <= 0) return;

      targets.first.style.setProperty('--rover-ai-gradient-span-height', span + 'px');
      root.style.setProperty('--rover-ai-gradient-span-height', span + 'px');
    }

    function scheduleGradientSpanUpdate() {
      if (scheduled) return;
      if (window.requestAnimationFrame) {
        scheduled = window.requestAnimationFrame(updateGradientSpan);
      } else {
        scheduled = window.setTimeout(updateGradientSpan, 16);
      }
    }

    function bindMediaLoadUpdates(targets) {
      targets.sections.forEach(function (section) {
        if (observer) observer.observe(section);
        section.querySelectorAll('img, video').forEach(function (media) {
          if (media.dataset.roverAiGradientSpanBound === 'true') return;
          media.dataset.roverAiGradientSpanBound = 'true';
          media.addEventListener('load', scheduleGradientSpanUpdate, { passive: true });
          media.addEventListener('loadedmetadata', scheduleGradientSpanUpdate, { passive: true });
          media.addEventListener('loadeddata', scheduleGradientSpanUpdate, { passive: true });
        });
      });
    }

    function refreshGradientTargets() {
      var targets = getGradientSections();
      if (!targets) return;
      bindMediaLoadUpdates(targets);
      scheduleGradientSpanUpdate();
      window.setTimeout(scheduleGradientSpanUpdate, 250);
      window.setTimeout(scheduleGradientSpanUpdate, 900);
    }

    window.__roverSyncAiGradientSpan = scheduleGradientSpanUpdate;

    if (!window.__roverAiGradientSpanInitialized) {
      window.__roverAiGradientSpanInitialized = true;
      if (window.ResizeObserver) {
        observer = new ResizeObserver(scheduleGradientSpanUpdate);
        window.__roverAiGradientSpanObserver = observer;
      }
      window.addEventListener('resize', scheduleGradientSpanUpdate, { passive: true });
      window.addEventListener('orientationchange', scheduleGradientSpanUpdate, { passive: true });
      window.addEventListener('load', scheduleGradientSpanUpdate, { passive: true });
      if (doc.fonts && doc.fonts.ready && typeof doc.fonts.ready.then === 'function') {
        doc.fonts.ready.then(scheduleGradientSpanUpdate).catch(function () {});
      }
      if (window.MutationObserver && doc.body) {
        window.__roverAiGradientSpanMutationObserver = new MutationObserver(refreshGradientTargets);
        window.__roverAiGradientSpanMutationObserver.observe(doc.body, { childList: true, subtree: true });
      }
    }

    refreshGradientTargets();
  }

  function initSectionMotion(scope) {
    var sections = Array.prototype.slice.call((scope || document).querySelectorAll('.rover-section'));
    if (!sections.length) return;

    var staticAfterVctClasses = ['rover-companion', 'rover-specs', 'rover-ai-tabs', 'rover-split', 'rover-audio', 'rover-box', 'rover-cta', 'rover-compare', 'rover-faq', 'rover-accessories', 'rover-dimensions'];

    function shouldSkipEntranceMotion(section) {
      return staticAfterVctClasses.some(function (className) {
        return section.classList.contains(className);
      });
    }

    function disableEntranceMotion(section) {
      section.classList.add('is-rover-visible');
      section.style.setProperty('opacity', '1', 'important');
      section.style.setProperty('filter', 'none', 'important');
      section.style.setProperty('transform', 'none', 'important');
      section.style.setProperty('transition', 'none', 'important');
      section.style.setProperty('animation', 'none', 'important');

      section.querySelectorAll('.rover-feature-card, .rover-feature-card__image, .rover-feature-card__layer, .rover-box__image, .rover-box__media, .rover-cta__media, .rover-compare-card__image, .rover-accessory-card__media').forEach(function (element) {
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('filter', 'none', 'important');
        element.style.setProperty('transform', 'none', 'important');
        element.style.setProperty('transition', 'none', 'important');
        element.style.setProperty('animation', 'none', 'important');
      });
    }

    document.documentElement.classList.add('rover-motion-ready');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      sections.forEach(function (section) { section.classList.add('is-rover-visible'); });
      return;
    }

    if (!window.__roverSectionMotionObserver) {
      window.__roverSectionMotionObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-rover-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.18 });
    }

    sections.forEach(function (section) {
      if (section.dataset.roverSectionMotionBound === 'true') return;
      section.dataset.roverSectionMotionBound = 'true';

      if (shouldSkipEntranceMotion(section)) {
        disableEntranceMotion(section);
        return;
      }

      if (section.classList.contains('rover-hero') || section.classList.contains('rover-video-stage')) {
        section.classList.add('is-rover-visible');
        return;
      }

      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      if (rect.top < viewportHeight * 0.88) {
        section.classList.add('is-rover-visible');
      } else {
        window.__roverSectionMotionObserver.observe(section);
      }
    });
  }

  /* 产品尺寸图：点缩略图看全尺寸。
     为什么需要：俯视图的标注字只占源图高度的 1.58%（实测源图 5000px 里 79px），
     折算到 375px 的舞台只有约 3.5px 高 —— 缩略图不可能读出来，放大是唯一解。
     用现成的 <img> 源做灯箱，不额外下载原图；Esc / 点背景 / 点关闭都能退出，
     焦点回到触发按钮。

     ⚠️ 灯箱必须挂到 <body>（见 ensureAtBody）：
     本板块的 <section> 被全局入场动效规则
     `html.rover-motion-ready .rover-section { will-change: opacity, transform }`
     命中，而 will-change 含 transform 会让该元素成为 position:fixed 后代的
     **包含块**。灯箱留在 section 内时，inset:0 是相对 section 而不是视口 ——
     实测灯箱被撑成 1440×646、位置跑到 y=11602（页面下方），遮罩只盖住一条
     与 section 等高的黑带，图还溢出到外面，就是用户看到的"放大有 bug"。
     挂到 body 后包含块回到视口，fixed 才真的是全屏。 */
  function ensureAtBody(el) {
    if (!el || !document.body) return;
    if (el.parentNode !== document.body) document.body.appendChild(el);
  }

  function initDimensionsZoom(scope) {
    var roots = [];
    var root = scope || document;
    if (root.matches && root.matches('[data-rover-dim-lightbox]')) roots.push(root);
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-rover-dim-lightbox]'));
    // 也把页面上已存在的灯箱一并挪到 body（theme editor 重渲染后 section 会被换掉）
    Array.prototype.slice.call(document.querySelectorAll('[data-rover-dim-lightbox]')).forEach(function (el) {
      if (boxes.indexOf(el) < 0) boxes.push(el);
    });
    boxes.forEach(function (box) {
      ensureAtBody(box);
      if (box.dataset.roverDimLightboxBound === 'true') return;
      box.dataset.roverDimLightboxBound = 'true';
      var img = box.querySelector('[data-rover-dim-lightbox-image]');
      var closeBtn = box.querySelector('.rover-dimensions__lightbox-close');
      var opener = null;

      function close() {
        var returnTo = opener;
        box.classList.remove('is-open');
        box.setAttribute('aria-hidden', 'true');
        box.hidden = true;
        document.documentElement.classList.remove('rover-dim-lightbox-open');
        document.documentElement.style.removeProperty('overflow');
        if (img) img.removeAttribute('src');
        opener = null;
        // 焦点交还给触发按钮。要放到下一帧再 focus：
        // 灯箱刚被隐藏的同一帧里，浏览器仍认为按钮被遮挡，
        // focus({preventScroll}) 会被静默丢弃（实测 activeElement 落到 body）。
        if (returnTo && returnTo.focus) {
          requestAnimationFrame(function () {
            returnTo.focus({ preventScroll: true });
            if (document.activeElement !== returnTo) returnTo.focus();
          });
        }
      }

      function open(trigger, src, alt) {
        if (!img) return;
        opener = trigger;
        img.src = src;
        img.alt = alt || '';
        box.hidden = false;
        box.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('rover-dim-lightbox-open');
        // 锁滚动必须直接写在 <html> 的 style 上：
        // 样式表里的 `html.rover-dim-lightbox-open { overflow: hidden }` 会被
        // 主题自带的高优先级规则盖掉（实测打开时 overflow 仍是 visible）。
        document.documentElement.style.setProperty('overflow', 'hidden', 'important');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }

      /* 点空白处退出。
         坑：`.lightbox-body` 铺满整个视口并且盖在 backdrop 之上，
         所以点空白处命中的是 body，不是 backdrop。
         早先只给 backdrop 挂关闭，等于「必须精确点到 body 之外」——
         而 body 就是全屏，永远点不到，用户反馈的"点空白处退不出"即此。
         现在的判定：点在 body 上、但不在图片上（也不在关闭按钮上）→ 关闭。
         这样点击图片本身不会误关，点图片周围的任何空白都会退出。 */
      box.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (target.closest('[data-rover-dim-lightbox-close]')) { close(); return; }
        if (target === img || (img && img.contains(target))) return;
        // 点到图片以外的任何地方都关闭（body / backdrop / hint 都算空白）
        close();
      });
      box.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
      });

      box.__roverDimOpen = open;
      box.__roverDimClose = close;
    });

    var triggers = Array.prototype.slice.call((scope || document).querySelectorAll('[data-rover-dim-zoom]'));
    triggers.forEach(function (trigger) {
      if (trigger.dataset.roverDimZoomBound === 'true') return;
      trigger.dataset.roverDimZoomBound = 'true';
      trigger.addEventListener('click', function () {
        var inner = trigger.querySelector('img');
        if (!inner) return;
        var box = document.querySelector('[data-rover-dim-lightbox]');
        if (!box || !box.__roverDimOpen) return;
        var full = inner.getAttribute('data-rover-dim-full') || inner.currentSrc || inner.src;
        box.__roverDimOpen(trigger, full, inner.alt);
      });
    });
  }

  function init(scope) {
    bindRoverCartLayerBridge();
    initOverlaySuppression(scope || document);
    initHeroLoad(scope || document);
    initDisclosureScrollAnchors(scope || document);
    initTabs(scope || document);
    initSpecsMedia(scope || document);
    initSplitAccordions(scope || document);
    initFaqAccordions(scope || document);
    initCompareTables(scope || document);
    initScrollers(scope || document);
    initDeferredMediaPreload(scope || document);
    initRoverAllVideoPreload(scope || document);
    applyRoverPurchaseRegionLock(scope || document);
    initPurchaseDrawer(scope || document);
    initWatchFilm(scope || document);
    initRoverBundleSelectors(scope || document);
    initPerspectiveScroll(scope || document);
    initVideoStageScroll(scope || document);
    initVideoPlayToggles(scope || document);
    initVisibleVideoPlayback(scope || document);
    initSectionMotion(scope || document);
    initDimensionsZoom(scope || document);
    initRoverContinuousAiGradientSpan(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
